import { useToggle as ti, useDeepCompareMemo as ha } from "@react-hookz/web";
import { g as ya, a as yn } from "./environment-BQ4WWa7b.mjs";
import * as T from "react";
import u, { createContext as Gn, useContext as qn, useCallback as me, useState as be, useMemo as De, useEffect as Ye, useLayoutEffect as Ea, useRef as Me, useDebugValue as _a } from "react";
import { Transition as Sa, SwitchTransition as ct } from "react-transition-group";
import { useLatest as ba } from "react-use";
import { u as re, a as va, b as Aa, R as Ca } from "./contexts-BhsnKQH-.mjs";
import { b as wa, u as Ta, a as xa } from "./tracking-impression-event-BSYv6VZE.mjs";
import { fetchQuery as ni, commitMutation as Ia } from "react-relay";
import { u as Lt } from "./fallback-storage-value-DraZAU_d.mjs";
import { n as Je, u as En, e as ka, b as Na, f as Oa } from "./index-CnymUPx7.mjs";
import { withEmotionCache as Ra, ThemeContext as ri, useTheme as Bt, css as ii } from "@emotion/react";
import { getRegisteredStyles as La, registerStyles as Pa, insertStyles as Ba } from "@emotion/utils";
import { b as le, f as H, a as mt } from "./variables-BSQ2K9t-.mjs";
import { useGoogleReCaptcha as Ua } from "react-google-recaptcha-v3";
import xr from "qs";
import { ThemeProvider as Fa } from "@mui/material";
import ai from "deepmerge";
import { t as oi } from "./breakpoints-DvaoDEis.mjs";
function _n() {
  return _n = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _n.apply(null, arguments);
}
function si(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var Ma = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Da = /* @__PURE__ */ si(
  function(e) {
    return Ma.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
function za(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Xa = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, $a = !1, ja = /[A-Z]|^ms/g, Ka = /_EMO_([^_]+?)_([^]*?)_EMO_/g, li = function(t) {
  return t.charCodeAt(1) === 45;
}, Ir = function(t) {
  return t != null && typeof t != "boolean";
}, an = /* @__PURE__ */ si(function(e) {
  return li(e) ? e : e.replace(ja, "-$&").toLowerCase();
}), kr = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Ka, function(r, i, a) {
          return _e = {
            name: i,
            styles: a,
            next: _e
          }, i;
        });
  }
  return Xa[t] !== 1 && !li(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
}, Va = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function pt(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var i = n;
      if (i.anim === 1)
        return _e = {
          name: i.name,
          styles: i.styles,
          next: _e
        }, i.name;
      var a = n;
      if (a.styles !== void 0) {
        var s = a.next;
        if (s !== void 0)
          for (; s !== void 0; )
            _e = {
              name: s.name,
              styles: s.styles,
              next: _e
            }, s = s.next;
        var l = a.styles + ";";
        return l;
      }
      return Ha(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var c = _e, g = n(e);
        return _e = c, pt(e, t, g);
      }
      break;
    }
  }
  var p = n;
  if (t == null)
    return p;
  var d = t[p];
  return d !== void 0 ? d : p;
}
function Ha(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += pt(e, t, n[i]) + ";";
  else
    for (var a in n) {
      var s = n[a];
      if (typeof s != "object") {
        var l = s;
        t != null && t[l] !== void 0 ? r += a + "{" + t[l] + "}" : Ir(l) && (r += an(a) + ":" + kr(a, l) + ";");
      } else {
        if (a === "NO_COMPONENT_SELECTOR" && $a)
          throw new Error(Va);
        if (Array.isArray(s) && typeof s[0] == "string" && (t == null || t[s[0]] === void 0))
          for (var c = 0; c < s.length; c++)
            Ir(s[c]) && (r += an(a) + ":" + kr(a, s[c]) + ";");
        else {
          var g = pt(e, t, s);
          switch (a) {
            case "animation":
            case "animationName": {
              r += an(a) + ":" + g + ";";
              break;
            }
            default:
              r += a + "{" + g + "}";
          }
        }
      }
    }
  return r;
}
var Nr = /label:\s*([^\s;{]+)\s*(;|$)/g, _e;
function Ga(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, i = "";
  _e = void 0;
  var a = e[0];
  if (a == null || a.raw === void 0)
    r = !1, i += pt(n, t, a);
  else {
    var s = a;
    i += s[0];
  }
  for (var l = 1; l < e.length; l++)
    if (i += pt(n, t, e[l]), r) {
      var c = a;
      i += c[l];
    }
  Nr.lastIndex = 0;
  for (var g = "", p; (p = Nr.exec(i)) !== null; )
    g += "-" + p[1];
  var d = za(i) + g;
  return {
    name: d,
    styles: i,
    next: _e
  };
}
var qa = function(t) {
  return t();
}, Wa = T.useInsertionEffect ? T.useInsertionEffect : !1, Ya = Wa || qa, Qa = { NEXT_PUBLIC_ENV_SLUG: "local", NEXT_PUBLIC_RECAPTCHA_CONTAINER_ID: "", NEXT_PUBLIC_SENTRY_ENABLE_TRACING: "false", NEXT_PUBLIC_SERVER_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_BYPASS_MIGRATE_ROUTE_CHECKING: "true", NEXT_PUBLIC_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_USER_PROFILE_PIC_PREFIX: "https://staging-scmp-d8.product-web.dev-2.scmp.tech/user/pic/", NX_WORKSPACE_ROOT: "/app", npm_config_user_agent: "pnpm/9.14.4 npm/? node/v20.18.1 linux arm64", NEXT_PUBLIC_ROSETTA_PIANO_APPLICATION_ID: "49ziQNIdsu", NODE_VERSION: "20.18.1", SENTRY_AUTH_TOKEN: "def7eadf085048aa825f3765be3b574d0a8f4b1da3184704b5b55b7c6d4faf25", STORYBOOK_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce=", STORYBOOK_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Fscmp%2F&width=86&layout=button_count&action=like&size=small&share=false&height=21&appId=282931841805811", HOSTNAME: "993cad9bdfa6", NEXT_PUBLIC_AI_ENGINE_FALLBACK_HOST: "https://data-assets-dev.i-scmp.com", NEXT_PUBLIC_DOMAIN_SCMP: "staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_REVERSE_PROXY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reverse-proxy/v1", NEXT_PUBLIC_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_SITE_URL: "https://local.product-web.dev-2.scmp.tech/", NEXT_PUBLIC_UNLEASH_APP_NAME: "QA-2/local", YARN_VERSION: "1.22.22", NX_VERBOSE_LOGGING: "false", HOME: "/root", NEXT_PUBLIC_ROSETTA_API_GATEWAY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech", STORYBOOK_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", STORYBOOK_CONTENTSERVICE_APIKEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PRIVATE_ROSETTA_PIANO_API_TOKEN: "0QV0rP7TUAXGFzF4B6EhP4EDjrbcaJRcpXsjSyax", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_GTM_CONTAINER_ID: "GTM-N3FDTB9", NEXT_PUBLIC_ROSETTA_PIANO_API_URL: "https://sandbox.tinypass.com/api/v3", NEXT_PUBLIC_SENTRY_DSN: "", UNLEASH_SERVER_API_TOKEN: "token", NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: "scmp-v4-1483944018736.appspot.com", OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_AI_ENGINE_HOST: "https://recommendation-endpoint-mock-dot-dotted-howl-175511.an.r.appspot.com", NEXT_PUBLIC_COMMIT_SHA: "123456", NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: "scmp-v4-1483944018736.firebaseapp.com", NEXT_PUBLIC_GA4_MEASUREMENT_ID: "G-FZRLBKLFVT", NEXT_PUBLIC_GPT_AD_UNIT_PREFIX: "scmptestsite.com/stagweb", STORYBOOK_RECAPTCHA_SITE_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", NEXT_PUBLIC_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_LOCATION_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", NEXT_PUBLIC_SERVICE_WORKER_CACHE_VERSION: "local-dev-sw", NEXT_PUBLIC_SUBSCRIPTION_TEMPLATE: "https://product-web-scmp-pwa-dev.oss-cn-hongkong.aliyuncs.com/subscription-template", FORCE_COLOR: "true", NEXT_PUBLIC_OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN: "api-key", OSS_BUCKET_NAME: "product-web-scmp-pwa-v2-dev", NEXT_PUBLIC_ELASTICSEARCH_API_KEY: "1DHVoK6d09e9Usm4Cvujj1vParXGv3Lt", STORYBOOK_ROSETTA_HOST: "https://subscribe.scmp.com", STORYBOOK_SITE_URL: "https://local.product-web.dev-2.scmp.tech/", NEXT_PUBLIC_ADVERTISEMENT_FAILSAFE_TIMEOUT: "2000", TERM: "xterm", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_URL: "https://ad-tech.scmp.com/dev/ad-viewability/v2", NEXT_PUBLIC_CANONICAL_BASE_URL: "https://local.product-web.dev.scmp.tech/", NEXT_PUBLIC_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_SOCIAL_API_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/share-count/v1", NX_TASK_HASH: "4295117324282027065", NEXT_PUBLIC_FIREBASE_PROJECT_ID: "scmp-v4-1483944018736", PATH: "./node_modules/.bin:/app/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", NEXT_PUBLIC_ADVERTISEMENT_CONFIG_ID: "scmp_pwa_advert", NEXT_PUBLIC_APPLICATION: "", NEXT_PUBLIC_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1", LERNA_PACKAGE_NAME: "scmp-sdk", NEXT_PUBLIC_COOKIE_DOMAIN: ".product-web.dev-2.scmp.tech", NEXT_PUBLIC_FIREBASE_APP_ID: "1:79414953154:web:5cf4f02b866c94c276675b", NEXT_PUBLIC_ELASTICSEARCH_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/search/v2", NEXT_PUBLIC_LOCATION_SERVICE_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/gloc/v1", NEXT_PUBLIC_NAVIGATOR_INFO_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NXCACHE_ALI_OSS_ACCESS_KEY: "LTAI5tGjA2LsWzhnKg5DzELK", GITLAB_CI_TOKEN: "glpat-hsEYPhLZnr3ioNHP6PWr", NEXT_PUBLIC_REGISTER_CALLBACK_URL: "https://local.product-web.dev-2.scmp.tech/centralize/register?email=", NEXT_PUBLIC_DRUPAL_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_ENVIRONMENT: "development", NEXT_PUBLIC_MAGNITE_DEMAND_MANAGER_SCRIPT_URL: "//micro.rubiconproject.com/prebid/dynamic/16912.js", NXCACHE_ALI_OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_GA4_MEASUREMENT_API_KEY: "arKY-GAXSnmOesqO9m1dJg", NEXT_PUBLIC_SEND_WELCOME_EMAIL: "false", NEXT_PUBLIC_USERSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_USER_FOLLOW_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/follow/v1", NODE_PATH: "/app/node_modules/.pnpm/nx@19.8.10_@swc-node+register@1.9.2_@swc+core@1.9.2_@swc+helpers@0.5.15__@swc+types@0.1.15_ty_sidkzcm5r3bnt2e4s3kmkdzuee/node_modules/nx/bin/node_modules:/app/node_modules/.pnpm/nx@19.8.10_@swc-node+register@1.9.2_@swc+core@1.9.2_@swc+helpers@0.5.15__@swc+types@0.1.15_ty_sidkzcm5r3bnt2e4s3kmkdzuee/node_modules/nx/node_modules:/app/node_modules/.pnpm/nx@19.8.10_@swc-node+register@1.9.2_@swc+core@1.9.2_@swc+helpers@0.5.15__@swc+types@0.1.15_ty_sidkzcm5r3bnt2e4s3kmkdzuee/node_modules:/app/node_modules/.pnpm/node_modules", NX_PSEUDO_TERMINAL_EXEC_ARGV: "", SHELL: "/bin/bash", STORYBOOK_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", NEXT_PUBLIC_PREBID_GA_PROFILE_ID: "UA-6891676-56", NX_CLI_SET: "true", OSS_ACCESS_KEY_ID: "LTAI5tGjA2LsWzhnKg5DzELK", OSS_REGION: "oss-cn-hongkong", UNLEASH_SERVER_INSTANCE_ID: "X3iT8KZpvqPDQ4MGy9ZT", NEXT_PUBLIC_AUTH_CALLBACK_URL: "https://local.product-web.dev-2.scmp.tech/centralize/signin?nonce=", NEXT_PUBLIC_DRUPAL_GRAPHQL_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/d8/v1", NEXT_PUBLIC_FIREBASE_API_KEY: "AIzaSyBBqdUTwUGIG16iit47ORy8YwN5CEDpgUI", OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_OLYMPICS_DATA_HOST: "https://assets-dev.i-scmp.com", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/pwa-v2-unleash-proxy-qa/proxy", NX_TASK_TARGET_TARGET: "build", NEXT_PUBLIC_DRUPAL_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/scmp-d8", NX_LOAD_DOT_ENV_FILES: "true", PNPM_PACKAGE_NAME: "scmp-pwa-v2", NEXT_PUBLIC_NAVIGATOR_INFO_URL: "/navigator-info", NEXT_PUBLIC_ROSETTA_ENVIRONMENT: "development", NX_TASK_TARGET_PROJECT: "scmp-sdk", STORYBOOK_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_AMP_READER_ID: "", NEXT_PUBLIC_USERSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-service/v1", PWD: "/app", NEXT_PUBLIC_GOOGLE_CLIENT_ID: "399013205570-169fssvc94c07pijogbv05knmkl7ap76.apps.googleusercontent.com", NEXT_PUBLIC_ROSETTA_PIANO_ENVIRONMENT: "sandbox", NEXT_PUBLIC_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", STORYBOOK_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1/tier", npm_command: "run-script", NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: "79414953154", NEXT_PUBLIC_READING_HISTORY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reading-history/v1", STORYBOOK_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email=", NEXT_PUBLIC_FIREBASE_URL: "https://scmp-development.firebaseio.com", NEXT_PUBLIC_RECAPTCHA_SITE_KEY: "6Lfnd_cnAAAAAH_TICwyQYw12cUdgHAH7-BZAfem", NEXT_PUBLIC_USER_TYPE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-type/v1", VITE_CJS_IGNORE_WARNING: "true", NODE_ENV: "production" }, Ja = Da, Za = function(t) {
  return t !== "theme";
}, Or = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? Ja : Za;
}, Rr = function(t, n, r) {
  var i;
  if (n) {
    var a = n.shouldForwardProp;
    i = t.__emotion_forwardProp && a ? function(s) {
      return t.__emotion_forwardProp(s) && a(s);
    } : a;
  }
  return typeof i != "function" && r && (i = t.__emotion_forwardProp), i;
}, eo = function(t) {
  var n = t.cache, r = t.serialized, i = t.isStringTag;
  return Pa(n, r, i), Ya(function() {
    return Ba(n, r, i);
  }), null;
}, E = function e(t, n) {
  var r = t.__emotion_real === t, i = r && t.__emotion_base || t, a, s;
  n !== void 0 && (a = n.label, s = n.target);
  var l = Rr(t, n, r), c = l || Or(i), g = !c("as");
  return function() {
    var p = arguments, d = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (a !== void 0 && d.push("label:" + a + ";"), p[0] == null || p[0].raw === void 0)
      d.push.apply(d, p);
    else {
      d.push(p[0][0]);
      for (var m = p.length, y = 1; y < m; y++)
        d.push(p[y], p[0][y]);
    }
    var _ = Ra(function(h, A, S) {
      var x = g && h.as || i, v = "", b = [], w = h;
      if (h.theme == null) {
        w = {};
        for (var I in h)
          w[I] = h[I];
        w.theme = T.useContext(ri);
      }
      typeof h.className == "string" ? v = La(A.registered, b, h.className) : h.className != null && (v = h.className + " ");
      var N = Ga(d.concat(b), A.registered, w);
      v += A.key + "-" + N.name, s !== void 0 && (v += " " + s);
      var k = g && l === void 0 ? Or(x) : c, L = {};
      for (var o in h)
        g && o === "as" || // $FlowFixMe
        k(o) && (L[o] = h[o]);
      return L.className = v, L.ref = S, /* @__PURE__ */ T.createElement(T.Fragment, null, /* @__PURE__ */ T.createElement(eo, {
        cache: A,
        serialized: N,
        isStringTag: typeof x == "string"
      }), /* @__PURE__ */ T.createElement(x, L));
    });
    return _.displayName = a !== void 0 ? a : "Styled(" + (typeof i == "string" ? i : i.displayName || i.name || "Component") + ")", _.defaultProps = t.defaultProps, _.__emotion_real = _, _.__emotion_base = i, _.__emotion_styles = d, _.__emotion_forwardProp = l, Object.defineProperty(_, "toString", {
      value: function() {
        return s === void 0 && Qa.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + s;
      }
    }), _.withComponent = function(h, A) {
      return e(h, _n({}, n, A, {
        shouldForwardProp: Rr(_, A, !0)
      })).apply(void 0, d);
    }, _;
  };
};
function to(e) {
  var t;
  return parseInt(T.version, 10) >= 19 ? ((t = e == null ? void 0 : e.props) == null ? void 0 : t.ref) || null : (e == null ? void 0 : e.ref) || null;
}
function ze(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
function ci(e) {
  if (typeof e != "string")
    throw new Error(ze(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Oe(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function ui(e) {
  if (!Oe(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = ui(e[n]);
  }), t;
}
function ne(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? {
    ...e
  } : e;
  return Oe(e) && Oe(t) && Object.keys(t).forEach((i) => {
    Oe(t[i]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, i) && Oe(e[i]) ? r[i] = ne(e[i], t[i], n) : n.clone ? r[i] = Oe(t[i]) ? ui(t[i]) : t[i] : r[i] = t[i];
  }), r;
}
function ut(e, t) {
  return t ? ne(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
function no(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((r) => r.startsWith("@container")).sort((r, i) => {
    var s, l;
    const a = /min-width:\s*([0-9.]+)/;
    return +(((s = r.match(a)) == null ? void 0 : s[1]) || 0) - +(((l = i.match(a)) == null ? void 0 : l[1]) || 0);
  });
  return n.length ? n.reduce((r, i) => {
    const a = t[i];
    return delete r[i], r[i] = a, r;
  }, {
    ...t
  }) : t;
}
function ro(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function io(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n)
    return null;
  const [, r, i] = n, a = Number.isNaN(+r) ? r || 0 : +r;
  return e.containerQueries(i).up(a);
}
function ao(e) {
  const t = (a, s) => a.replace("@media", s ? `@container ${s}` : "@container");
  function n(a, s) {
    a.up = (...l) => t(e.breakpoints.up(...l), s), a.down = (...l) => t(e.breakpoints.down(...l), s), a.between = (...l) => t(e.breakpoints.between(...l), s), a.only = (...l) => t(e.breakpoints.only(...l), s), a.not = (...l) => {
      const c = t(e.breakpoints.not(...l), s);
      return c.includes("not all and") ? c.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : c;
    };
  }
  const r = {}, i = (a) => (n(r, a), r);
  return n(i), {
    ...e,
    containerQueries: i
  };
}
const Ut = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, Lr = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Ut[e]}px)`
}, oo = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : Ut[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function Te(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const a = r.breakpoints || Lr;
    return t.reduce((s, l, c) => (s[a.up(a.keys[c])] = n(t[c]), s), {});
  }
  if (typeof t == "object") {
    const a = r.breakpoints || Lr;
    return Object.keys(t).reduce((s, l) => {
      if (ro(a.keys, l)) {
        const c = io(r.containerQueries ? r : oo, l);
        c && (s[c] = n(t[l], l));
      } else if (Object.keys(a.values || Ut).includes(l)) {
        const c = a.up(l);
        s[c] = n(t[l], l);
      } else {
        const c = l;
        s[c] = t[c];
      }
      return s;
    }, {});
  }
  return n(t);
}
function so(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((r, i) => {
    const a = e.up(i);
    return r[a] = {}, r;
  }, {})) || {};
}
function lo(e, t) {
  return e.reduce((n, r) => {
    const i = n[r];
    return (!i || Object.keys(i).length === 0) && delete n[r], n;
  }, t);
}
function Ft(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((i, a) => i && i[a] ? i[a] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, i) => r && r[i] != null ? r[i] : null, e);
}
function Pt(e, t, n, r = n) {
  let i;
  return typeof e == "function" ? i = e(n) : Array.isArray(e) ? i = e[n] || r : i = Ft(e, n) || r, t && (i = t(i, r, e)), i;
}
function G(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: i
  } = e, a = (s) => {
    if (s[t] == null)
      return null;
    const l = s[t], c = s.theme, g = Ft(c, r) || {};
    return Te(s, l, (d) => {
      let m = Pt(g, i, d);
      return d === m && typeof d == "string" && (m = Pt(g, i, `${t}${d === "default" ? "" : ci(d)}`, d)), n === !1 ? m : {
        [n]: m
      };
    });
  };
  return a.propTypes = {}, a.filterProps = [t], a;
}
function co(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const uo = {
  m: "margin",
  p: "padding"
}, mo = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, Pr = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, po = co((e) => {
  if (e.length > 2)
    if (Pr[e])
      e = Pr[e];
    else
      return [e];
  const [t, n] = e.split(""), r = uo[t], i = mo[n] || "";
  return Array.isArray(i) ? i.map((a) => r + a) : [r + i];
}), Wn = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Yn = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
[...Wn, ...Yn];
function bt(e, t, n, r) {
  const i = Ft(e, t, !0) ?? n;
  return typeof i == "number" || typeof i == "string" ? (a) => typeof a == "string" ? a : typeof i == "string" ? `calc(${a} * ${i})` : i * a : Array.isArray(i) ? (a) => {
    if (typeof a == "string")
      return a;
    const s = Math.abs(a), l = i[s];
    return a >= 0 ? l : typeof l == "number" ? -l : `-${l}`;
  } : typeof i == "function" ? i : () => {
  };
}
function Qn(e) {
  return bt(e, "spacing", 8);
}
function vt(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function fo(e, t) {
  return (n) => e.reduce((r, i) => (r[i] = vt(t, n), r), {});
}
function go(e, t, n, r) {
  if (!t.includes(n))
    return null;
  const i = po(n), a = fo(i, r), s = e[n];
  return Te(e, s, a);
}
function di(e, t) {
  const n = Qn(e.theme);
  return Object.keys(e).map((r) => go(e, t, r, n)).reduce(ut, {});
}
function $(e) {
  return di(e, Wn);
}
$.propTypes = {};
$.filterProps = Wn;
function j(e) {
  return di(e, Yn);
}
j.propTypes = {};
j.filterProps = Yn;
function Mt(...e) {
  const t = e.reduce((r, i) => (i.filterProps.forEach((a) => {
    r[a] = i;
  }), r), {}), n = (r) => Object.keys(r).reduce((i, a) => t[a] ? ut(i, t[a](r)) : i, {});
  return n.propTypes = {}, n.filterProps = e.reduce((r, i) => r.concat(i.filterProps), []), n;
}
function ae(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function ue(e, t) {
  return G({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const ho = ue("border", ae), yo = ue("borderTop", ae), Eo = ue("borderRight", ae), _o = ue("borderBottom", ae), So = ue("borderLeft", ae), bo = ue("borderColor"), vo = ue("borderTopColor"), Ao = ue("borderRightColor"), Co = ue("borderBottomColor"), wo = ue("borderLeftColor"), To = ue("outline", ae), xo = ue("outlineColor"), Dt = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = bt(e.theme, "shape.borderRadius", 4), n = (r) => ({
      borderRadius: vt(t, r)
    });
    return Te(e, e.borderRadius, n);
  }
  return null;
};
Dt.propTypes = {};
Dt.filterProps = ["borderRadius"];
Mt(ho, yo, Eo, _o, So, bo, vo, Ao, Co, wo, Dt, To, xo);
const zt = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = bt(e.theme, "spacing", 8), n = (r) => ({
      gap: vt(t, r)
    });
    return Te(e, e.gap, n);
  }
  return null;
};
zt.propTypes = {};
zt.filterProps = ["gap"];
const Xt = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = bt(e.theme, "spacing", 8), n = (r) => ({
      columnGap: vt(t, r)
    });
    return Te(e, e.columnGap, n);
  }
  return null;
};
Xt.propTypes = {};
Xt.filterProps = ["columnGap"];
const $t = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = bt(e.theme, "spacing", 8), n = (r) => ({
      rowGap: vt(t, r)
    });
    return Te(e, e.rowGap, n);
  }
  return null;
};
$t.propTypes = {};
$t.filterProps = ["rowGap"];
const Io = G({
  prop: "gridColumn"
}), ko = G({
  prop: "gridRow"
}), No = G({
  prop: "gridAutoFlow"
}), Oo = G({
  prop: "gridAutoColumns"
}), Ro = G({
  prop: "gridAutoRows"
}), Lo = G({
  prop: "gridTemplateColumns"
}), Po = G({
  prop: "gridTemplateRows"
}), Bo = G({
  prop: "gridTemplateAreas"
}), Uo = G({
  prop: "gridArea"
});
Mt(zt, Xt, $t, Io, ko, No, Oo, Ro, Lo, Po, Bo, Uo);
function Qe(e, t) {
  return t === "grey" ? t : e;
}
const Fo = G({
  prop: "color",
  themeKey: "palette",
  transform: Qe
}), Mo = G({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Qe
}), Do = G({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Qe
});
Mt(Fo, Mo, Do);
function te(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const zo = G({
  prop: "width",
  transform: te
}), Jn = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var i, a, s, l, c;
      const r = ((s = (a = (i = e.theme) == null ? void 0 : i.breakpoints) == null ? void 0 : a.values) == null ? void 0 : s[n]) || Ut[n];
      return r ? ((c = (l = e.theme) == null ? void 0 : l.breakpoints) == null ? void 0 : c.unit) !== "px" ? {
        maxWidth: `${r}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: r
      } : {
        maxWidth: te(n)
      };
    };
    return Te(e, e.maxWidth, t);
  }
  return null;
};
Jn.filterProps = ["maxWidth"];
const Xo = G({
  prop: "minWidth",
  transform: te
}), $o = G({
  prop: "height",
  transform: te
}), jo = G({
  prop: "maxHeight",
  transform: te
}), Ko = G({
  prop: "minHeight",
  transform: te
});
G({
  prop: "size",
  cssProperty: "width",
  transform: te
});
G({
  prop: "size",
  cssProperty: "height",
  transform: te
});
const Vo = G({
  prop: "boxSizing"
});
Mt(zo, Jn, Xo, $o, jo, Ko, Vo);
const jt = {
  // borders
  border: {
    themeKey: "borders",
    transform: ae
  },
  borderTop: {
    themeKey: "borders",
    transform: ae
  },
  borderRight: {
    themeKey: "borders",
    transform: ae
  },
  borderBottom: {
    themeKey: "borders",
    transform: ae
  },
  borderLeft: {
    themeKey: "borders",
    transform: ae
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: ae
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Dt
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Qe
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Qe
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Qe
  },
  // spacing
  p: {
    style: j
  },
  pt: {
    style: j
  },
  pr: {
    style: j
  },
  pb: {
    style: j
  },
  pl: {
    style: j
  },
  px: {
    style: j
  },
  py: {
    style: j
  },
  padding: {
    style: j
  },
  paddingTop: {
    style: j
  },
  paddingRight: {
    style: j
  },
  paddingBottom: {
    style: j
  },
  paddingLeft: {
    style: j
  },
  paddingX: {
    style: j
  },
  paddingY: {
    style: j
  },
  paddingInline: {
    style: j
  },
  paddingInlineStart: {
    style: j
  },
  paddingInlineEnd: {
    style: j
  },
  paddingBlock: {
    style: j
  },
  paddingBlockStart: {
    style: j
  },
  paddingBlockEnd: {
    style: j
  },
  m: {
    style: $
  },
  mt: {
    style: $
  },
  mr: {
    style: $
  },
  mb: {
    style: $
  },
  ml: {
    style: $
  },
  mx: {
    style: $
  },
  my: {
    style: $
  },
  margin: {
    style: $
  },
  marginTop: {
    style: $
  },
  marginRight: {
    style: $
  },
  marginBottom: {
    style: $
  },
  marginLeft: {
    style: $
  },
  marginX: {
    style: $
  },
  marginY: {
    style: $
  },
  marginInline: {
    style: $
  },
  marginInlineStart: {
    style: $
  },
  marginInlineEnd: {
    style: $
  },
  marginBlock: {
    style: $
  },
  marginBlockStart: {
    style: $
  },
  marginBlockEnd: {
    style: $
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: zt
  },
  rowGap: {
    style: $t
  },
  columnGap: {
    style: Xt
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: te
  },
  maxWidth: {
    style: Jn
  },
  minWidth: {
    transform: te
  },
  height: {
    transform: te
  },
  maxHeight: {
    transform: te
  },
  minHeight: {
    transform: te
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function Ho(...e) {
  const t = e.reduce((r, i) => r.concat(Object.keys(i)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function Go(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function qo() {
  function e(n, r, i, a) {
    const s = {
      [n]: r,
      theme: i
    }, l = a[n];
    if (!l)
      return {
        [n]: r
      };
    const {
      cssProperty: c = n,
      themeKey: g,
      transform: p,
      style: d
    } = l;
    if (r == null)
      return null;
    if (g === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const m = Ft(i, g) || {};
    return d ? d(s) : Te(s, r, (_) => {
      let h = Pt(m, p, _);
      return _ === h && typeof _ == "string" && (h = Pt(m, p, `${n}${_ === "default" ? "" : ci(_)}`, _)), c === !1 ? h : {
        [c]: h
      };
    });
  }
  function t(n) {
    const {
      sx: r,
      theme: i = {}
    } = n || {};
    if (!r)
      return null;
    const a = i.unstable_sxConfig ?? jt;
    function s(l) {
      let c = l;
      if (typeof l == "function")
        c = l(i);
      else if (typeof l != "object")
        return l;
      if (!c)
        return null;
      const g = so(i.breakpoints), p = Object.keys(g);
      let d = g;
      return Object.keys(c).forEach((m) => {
        const y = Go(c[m], i);
        if (y != null)
          if (typeof y == "object")
            if (a[m])
              d = ut(d, e(m, y, i, a));
            else {
              const _ = Te({
                theme: i
              }, y, (h) => ({
                [m]: h
              }));
              Ho(_, y) ? d[m] = t({
                sx: y,
                theme: i
              }) : d = ut(d, _);
            }
          else
            d = ut(d, e(m, y, i, a));
      }), no(i, lo(p, d));
    }
    return Array.isArray(r) ? r.map(s) : s(r);
  }
  return t;
}
const Kt = qo();
Kt.filterProps = ["sx"];
var mi = { exports: {} }, rt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Br;
function Wo() {
  if (Br) return rt;
  Br = 1;
  var e = u, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, g) {
    var p, d = {}, m = null, y = null;
    g !== void 0 && (m = "" + g), c.key !== void 0 && (m = "" + c.key), c.ref !== void 0 && (y = c.ref);
    for (p in c) r.call(c, p) && !a.hasOwnProperty(p) && (d[p] = c[p]);
    if (l && l.defaultProps) for (p in c = l.defaultProps, c) d[p] === void 0 && (d[p] = c[p]);
    return { $$typeof: t, type: l, key: m, ref: y, props: d, _owner: i.current };
  }
  return rt.Fragment = n, rt.jsx = s, rt.jsxs = s, rt;
}
mi.exports = Wo();
var Yo = mi.exports;
const Qo = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => ({
    ...n,
    [r.key]: r.val
  }), {});
};
function Jo(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5,
    ...i
  } = e, a = Qo(t), s = Object.keys(a);
  function l(m) {
    return `@media (min-width:${typeof t[m] == "number" ? t[m] : m}${n})`;
  }
  function c(m) {
    return `@media (max-width:${(typeof t[m] == "number" ? t[m] : m) - r / 100}${n})`;
  }
  function g(m, y) {
    const _ = s.indexOf(y);
    return `@media (min-width:${typeof t[m] == "number" ? t[m] : m}${n}) and (max-width:${(_ !== -1 && typeof t[s[_]] == "number" ? t[s[_]] : y) - r / 100}${n})`;
  }
  function p(m) {
    return s.indexOf(m) + 1 < s.length ? g(m, s[s.indexOf(m) + 1]) : l(m);
  }
  function d(m) {
    const y = s.indexOf(m);
    return y === 0 ? l(s[1]) : y === s.length - 1 ? c(s[y]) : g(m, s[s.indexOf(m) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: s,
    values: a,
    up: l,
    down: c,
    between: g,
    only: p,
    not: d,
    unit: n,
    ...i
  };
}
const Zo = {
  borderRadius: 4
};
function pi(e = 8, t = Qn({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...r) => (r.length === 0 ? [1] : r).map((a) => {
    const s = t(a);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" ");
  return n.mui = !0, n;
}
function es(e, t) {
  var r;
  const n = this;
  if (n.vars) {
    if (!((r = n.colorSchemes) != null && r[e]) || typeof n.getColorSchemeSelector != "function")
      return {};
    let i = n.getColorSchemeSelector(e);
    return i === "&" ? t : ((i.includes("data-") || i.includes(".")) && (i = `*:where(${i.replace(/\s*&$/, "")}) &`), {
      [i]: t
    });
  }
  return n.palette.mode === e ? t : {};
}
function fi(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: i,
    shape: a = {},
    ...s
  } = e, l = Jo(n), c = pi(i);
  let g = ne({
    breakpoints: l,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...r
    },
    spacing: c,
    shape: {
      ...Zo,
      ...a
    }
  }, s);
  return g = ao(g), g.applyStyles = es, g = t.reduce((p, d) => ne(p, d), g), g.unstable_sxConfig = {
    ...jt,
    ...s == null ? void 0 : s.unstable_sxConfig
  }, g.unstable_sx = function(d) {
    return Kt({
      sx: d,
      theme: this
    });
  }, g;
}
function ts(e) {
  return Object.keys(e).length === 0;
}
function ns(e = null) {
  const t = T.useContext(ri);
  return !t || ts(t) ? e : t;
}
const rs = fi();
function is(e = rs) {
  return ns(e);
}
function as(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
var os = { NEXT_PUBLIC_ENV_SLUG: "local", NEXT_PUBLIC_RECAPTCHA_CONTAINER_ID: "", NEXT_PUBLIC_SENTRY_ENABLE_TRACING: "false", NEXT_PUBLIC_SERVER_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_BYPASS_MIGRATE_ROUTE_CHECKING: "true", NEXT_PUBLIC_GA_PROFILE_ID: "UA-6891676-56", NEXT_PUBLIC_USER_PROFILE_PIC_PREFIX: "https://staging-scmp-d8.product-web.dev-2.scmp.tech/user/pic/", NX_WORKSPACE_ROOT: "/app", npm_config_user_agent: "pnpm/9.14.4 npm/? node/v20.18.1 linux arm64", NEXT_PUBLIC_ROSETTA_PIANO_APPLICATION_ID: "49ziQNIdsu", NODE_VERSION: "20.18.1", SENTRY_AUTH_TOKEN: "def7eadf085048aa825f3765be3b574d0a8f4b1da3184704b5b55b7c6d4faf25", STORYBOOK_AUTH_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/signin?nonce=", STORYBOOK_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Fscmp%2F&width=86&layout=button_count&action=like&size=small&share=false&height=21&appId=282931841805811", HOSTNAME: "993cad9bdfa6", NEXT_PUBLIC_AI_ENGINE_FALLBACK_HOST: "https://data-assets-dev.i-scmp.com", NEXT_PUBLIC_DOMAIN_SCMP: "staging-scmp-pwa.product-web.dev-2.scmp.tech", NEXT_PUBLIC_REVERSE_PROXY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reverse-proxy/v1", NEXT_PUBLIC_ROSETTA_HOST: "https://staging-rosetta.product-web.dev-2.scmp.tech", NEXT_PUBLIC_SITE_URL: "https://local.product-web.dev-2.scmp.tech/", NEXT_PUBLIC_UNLEASH_APP_NAME: "QA-2/local", YARN_VERSION: "1.22.22", NX_VERBOSE_LOGGING: "false", HOME: "/root", NEXT_PUBLIC_ROSETTA_API_GATEWAY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech", STORYBOOK_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", STORYBOOK_CONTENTSERVICE_APIKEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PRIVATE_ROSETTA_PIANO_API_TOKEN: "0QV0rP7TUAXGFzF4B6EhP4EDjrbcaJRcpXsjSyax", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_GTM_CONTAINER_ID: "GTM-N3FDTB9", NEXT_PUBLIC_ROSETTA_PIANO_API_URL: "https://sandbox.tinypass.com/api/v3", NEXT_PUBLIC_SENTRY_DSN: "", UNLEASH_SERVER_API_TOKEN: "token", NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: "scmp-v4-1483944018736.appspot.com", OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_AI_ENGINE_HOST: "https://recommendation-endpoint-mock-dot-dotted-howl-175511.an.r.appspot.com", NEXT_PUBLIC_COMMIT_SHA: "123456", NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: "scmp-v4-1483944018736.firebaseapp.com", NEXT_PUBLIC_GA4_MEASUREMENT_ID: "G-FZRLBKLFVT", NEXT_PUBLIC_GPT_AD_UNIT_PREFIX: "scmptestsite.com/stagweb", STORYBOOK_RECAPTCHA_SITE_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", NEXT_PUBLIC_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_LOCATION_SERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", NEXT_PUBLIC_SERVICE_WORKER_CACHE_VERSION: "local-dev-sw", NEXT_PUBLIC_SUBSCRIPTION_TEMPLATE: "https://product-web-scmp-pwa-dev.oss-cn-hongkong.aliyuncs.com/subscription-template", FORCE_COLOR: "true", NEXT_PUBLIC_OSS_HOST: "assets-v2-dev.i-scmp.com", NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN: "api-key", OSS_BUCKET_NAME: "product-web-scmp-pwa-v2-dev", NEXT_PUBLIC_ELASTICSEARCH_API_KEY: "1DHVoK6d09e9Usm4Cvujj1vParXGv3Lt", STORYBOOK_ROSETTA_HOST: "https://subscribe.scmp.com", STORYBOOK_SITE_URL: "https://local.product-web.dev-2.scmp.tech/", NEXT_PUBLIC_ADVERTISEMENT_FAILSAFE_TIMEOUT: "2000", TERM: "xterm", NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_URL: "https://ad-tech.scmp.com/dev/ad-viewability/v2", NEXT_PUBLIC_CANONICAL_BASE_URL: "https://local.product-web.dev.scmp.tech/", NEXT_PUBLIC_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_SOCIAL_API_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/share-count/v1", NX_TASK_HASH: "4295117324282027065", NEXT_PUBLIC_FIREBASE_PROJECT_ID: "scmp-v4-1483944018736", PATH: "./node_modules/.bin:/app/node_modules/.bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", NEXT_PUBLIC_ADVERTISEMENT_CONFIG_ID: "scmp_pwa_advert", NEXT_PUBLIC_APPLICATION: "", NEXT_PUBLIC_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1", LERNA_PACKAGE_NAME: "scmp-sdk", NEXT_PUBLIC_COOKIE_DOMAIN: ".product-web.dev-2.scmp.tech", NEXT_PUBLIC_FIREBASE_APP_ID: "1:79414953154:web:5cf4f02b866c94c276675b", NEXT_PUBLIC_ELASTICSEARCH_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/search/v2", NEXT_PUBLIC_LOCATION_SERVICE_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/gloc/v1", NEXT_PUBLIC_NAVIGATOR_INFO_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NXCACHE_ALI_OSS_ACCESS_KEY: "LTAI5tGjA2LsWzhnKg5DzELK", GITLAB_CI_TOKEN: "glpat-hsEYPhLZnr3ioNHP6PWr", NEXT_PUBLIC_REGISTER_CALLBACK_URL: "https://local.product-web.dev-2.scmp.tech/centralize/register?email=", NEXT_PUBLIC_DRUPAL_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_ENVIRONMENT: "development", NEXT_PUBLIC_MAGNITE_DEMAND_MANAGER_SCRIPT_URL: "//micro.rubiconproject.com/prebid/dynamic/16912.js", NXCACHE_ALI_OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_GA4_MEASUREMENT_API_KEY: "arKY-GAXSnmOesqO9m1dJg", NEXT_PUBLIC_SEND_WELCOME_EMAIL: "false", NEXT_PUBLIC_USERSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_USER_FOLLOW_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/follow/v1", NODE_PATH: "/app/node_modules/.pnpm/nx@19.8.10_@swc-node+register@1.9.2_@swc+core@1.9.2_@swc+helpers@0.5.15__@swc+types@0.1.15_ty_sidkzcm5r3bnt2e4s3kmkdzuee/node_modules/nx/bin/node_modules:/app/node_modules/.pnpm/nx@19.8.10_@swc-node+register@1.9.2_@swc+core@1.9.2_@swc+helpers@0.5.15__@swc+types@0.1.15_ty_sidkzcm5r3bnt2e4s3kmkdzuee/node_modules/nx/node_modules:/app/node_modules/.pnpm/nx@19.8.10_@swc-node+register@1.9.2_@swc+core@1.9.2_@swc+helpers@0.5.15__@swc+types@0.1.15_ty_sidkzcm5r3bnt2e4s3kmkdzuee/node_modules:/app/node_modules/.pnpm/node_modules", NX_PSEUDO_TERMINAL_EXEC_ARGV: "", SHELL: "/bin/bash", STORYBOOK_MIXPANEL_TOKEN: "3df890e68e74400967bcce74686c7f16", NEXT_PUBLIC_PREBID_GA_PROFILE_ID: "UA-6891676-56", NX_CLI_SET: "true", OSS_ACCESS_KEY_ID: "LTAI5tGjA2LsWzhnKg5DzELK", OSS_REGION: "oss-cn-hongkong", UNLEASH_SERVER_INSTANCE_ID: "X3iT8KZpvqPDQ4MGy9ZT", NEXT_PUBLIC_AUTH_CALLBACK_URL: "https://local.product-web.dev-2.scmp.tech/centralize/signin?nonce=", NEXT_PUBLIC_DRUPAL_GRAPHQL_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/d8/v1", NEXT_PUBLIC_FIREBASE_API_KEY: "AIzaSyBBqdUTwUGIG16iit47ORy8YwN5CEDpgUI", OSS_ACCESS_KEY_SECRET: "vXUaB7s1JHQsroz5s8gnD1g4XJrHnD", NEXT_PUBLIC_OLYMPICS_DATA_HOST: "https://assets-dev.i-scmp.com", NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_API_KEY: "mRAjzjXfX540GrvOAyW8iB0rdvEq08Xp", NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL: "https://staging-apigw.product-web.dev-2.scmp.tech/pwa-v2-unleash-proxy-qa/proxy", NX_TASK_TARGET_TARGET: "build", NEXT_PUBLIC_DRUPAL_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/scmp-d8", NX_LOAD_DOT_ENV_FILES: "true", PNPM_PACKAGE_NAME: "scmp-pwa-v2", NEXT_PUBLIC_NAVIGATOR_INFO_URL: "/navigator-info", NEXT_PUBLIC_ROSETTA_ENVIRONMENT: "development", NX_TASK_TARGET_PROJECT: "scmp-sdk", STORYBOOK_CONTENTSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/content-delivery/v2", NEXT_PUBLIC_AMP_READER_ID: "", NEXT_PUBLIC_USERSERVICE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-service/v1", PWD: "/app", NEXT_PUBLIC_GOOGLE_CLIENT_ID: "399013205570-169fssvc94c07pijogbv05knmkl7ap76.apps.googleusercontent.com", NEXT_PUBLIC_ROSETTA_PIANO_ENVIRONMENT: "sandbox", NEXT_PUBLIC_SCMP_ACCOUNT_HOST: "https://staging-scmp-account.product-web.dev-2.scmp.tech", STORYBOOK_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1/tier", npm_command: "run-script", NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: "79414953154", NEXT_PUBLIC_READING_HISTORY_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/reading-history/v1", STORYBOOK_REGISTER_CALLBACK_URL: "https://staging-scmp-pwa.product-web.dev-2.scmp.tech/centralize/register?email=", NEXT_PUBLIC_FIREBASE_URL: "https://scmp-development.firebaseio.com", NEXT_PUBLIC_RECAPTCHA_SITE_KEY: "6Lfnd_cnAAAAAH_TICwyQYw12cUdgHAH7-BZAfem", NEXT_PUBLIC_USER_TYPE_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/user-type/v1", VITE_CJS_IGNORE_WARNING: "true", NODE_ENV: "production" };
function Zn(e, t = 0, n = 1) {
  return as(e, t, n);
}
function ss(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, i) => i < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Le(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Le(ss(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(ze(9, e));
  let r = e.substring(t + 1, e.length - 1), i;
  if (n === "color") {
    if (r = r.split(" "), i = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(i))
      throw new Error(ze(10, i));
  } else
    r = r.split(",");
  return r = r.map((a) => parseFloat(a)), {
    type: n,
    values: r,
    colorSpace: i
  };
}
const ls = (e) => {
  const t = Le(e);
  return t.values.slice(0, 3).map((n, r) => t.type.includes("hsl") && r !== 0 ? `${n}%` : n).join(" ");
}, st = (e, t) => {
  try {
    return ls(e);
  } catch {
    return t && os.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function Vt(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.includes("rgb") ? r = r.map((i, a) => a < 3 ? parseInt(i, 10) : i) : t.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.includes("color") ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function gi(e) {
  e = Le(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, i = t[2] / 100, a = r * Math.min(i, 1 - i), s = (g, p = (g + n / 30) % 12) => i - a * Math.max(Math.min(p - 3, 9 - p, 1), -1);
  let l = "rgb";
  const c = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (l += "a", c.push(t[3])), Vt({
    type: l,
    values: c
  });
}
function Sn(e) {
  e = Le(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Le(gi(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function cs(e, t) {
  const n = Sn(e), r = Sn(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function us(e, t) {
  return e = Le(e), t = Zn(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, Vt(e);
}
function kt(e, t, n) {
  try {
    return us(e, t);
  } catch {
    return e;
  }
}
function er(e, t) {
  if (e = Le(e), t = Zn(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return Vt(e);
}
function U(e, t, n) {
  try {
    return er(e, t);
  } catch {
    return e;
  }
}
function tr(e, t) {
  if (e = Le(e), t = Zn(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return Vt(e);
}
function F(e, t, n) {
  try {
    return tr(e, t);
  } catch {
    return e;
  }
}
function ds(e, t = 0.15) {
  return Sn(e) > 0.5 ? er(e, t) : tr(e, t);
}
function Nt(e, t, n) {
  try {
    return ds(e, t);
  } catch {
    return e;
  }
}
function ms(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function ps(...e) {
  return T.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      ms(n, t);
    });
  }, e);
}
function fs(e = "") {
  function t(...r) {
    if (!r.length)
      return "";
    const i = r[0];
    return typeof i == "string" && !i.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${i}${t(...r.slice(1))})` : `, ${i}`;
  }
  return (r, ...i) => `var(--${e ? `${e}-` : ""}${r}${t(...i)})`;
}
const Ur = (e, t, n, r = []) => {
  let i = e;
  t.forEach((a, s) => {
    s === t.length - 1 ? Array.isArray(i) ? i[Number(a)] = n : i && typeof i == "object" && (i[a] = n) : i && typeof i == "object" && (i[a] || (i[a] = r.includes(a) ? [] : {}), i = i[a]);
  });
}, gs = (e, t, n) => {
  function r(i, a = [], s = []) {
    Object.entries(i).forEach(([l, c]) => {
      (!n || n && !n([...a, l])) && c != null && (typeof c == "object" && Object.keys(c).length > 0 ? r(c, [...a, l], Array.isArray(c) ? [...s, l] : s) : t([...a, l], c, s));
    });
  }
  r(e);
}, hs = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((r) => e.includes(r)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function on(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: r
  } = t || {}, i = {}, a = {}, s = {};
  return gs(
    e,
    (l, c, g) => {
      if ((typeof c == "string" || typeof c == "number") && (!r || !r(l, c))) {
        const p = `--${n ? `${n}-` : ""}${l.join("-")}`, d = hs(l, c);
        Object.assign(i, {
          [p]: d
        }), Ur(a, l, `var(${p})`, g), Ur(s, l, `var(${p}, ${d})`, g);
      }
    },
    (l) => l[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: i,
    vars: a,
    varsWithDefaults: s
  };
}
function ys(e, t = {}) {
  const {
    getSelector: n = A,
    disableCssColorScheme: r,
    colorSchemeSelector: i
  } = t, {
    colorSchemes: a = {},
    components: s,
    defaultColorScheme: l = "light",
    ...c
  } = e, {
    vars: g,
    css: p,
    varsWithDefaults: d
  } = on(c, t);
  let m = d;
  const y = {}, {
    [l]: _,
    ...h
  } = a;
  if (Object.entries(h || {}).forEach(([v, b]) => {
    const {
      vars: w,
      css: I,
      varsWithDefaults: N
    } = on(b, t);
    m = ne(m, N), y[v] = {
      css: I,
      vars: w
    };
  }), _) {
    const {
      css: v,
      vars: b,
      varsWithDefaults: w
    } = on(_, t);
    m = ne(m, w), y[l] = {
      css: v,
      vars: b
    };
  }
  function A(v, b) {
    var I, N;
    let w = i;
    if (i === "class" && (w = ".%s"), i === "data" && (w = "[data-%s]"), i != null && i.startsWith("data-") && !i.includes("%s") && (w = `[${i}="%s"]`), v) {
      if (w === "media")
        return e.defaultColorScheme === v ? ":root" : {
          [`@media (prefers-color-scheme: ${((N = (I = a[v]) == null ? void 0 : I.palette) == null ? void 0 : N.mode) || v})`]: {
            ":root": b
          }
        };
      if (w)
        return e.defaultColorScheme === v ? `:root, ${w.replace("%s", String(v))}` : w.replace("%s", String(v));
    }
    return ":root";
  }
  return {
    vars: m,
    generateThemeVars: () => {
      let v = {
        ...g
      };
      return Object.entries(y).forEach(([, {
        vars: b
      }]) => {
        v = ne(v, b);
      }), v;
    },
    generateStyleSheets: () => {
      var k, L;
      const v = [], b = e.defaultColorScheme || "light";
      function w(o, C) {
        Object.keys(C).length && v.push(typeof o == "string" ? {
          [o]: {
            ...C
          }
        } : o);
      }
      w(n(void 0, {
        ...p
      }), p);
      const {
        [b]: I,
        ...N
      } = y;
      if (I) {
        const {
          css: o
        } = I, C = (L = (k = a[b]) == null ? void 0 : k.palette) == null ? void 0 : L.mode, O = !r && C ? {
          colorScheme: C,
          ...o
        } : {
          ...o
        };
        w(n(b, {
          ...O
        }), O);
      }
      return Object.entries(N).forEach(([o, {
        css: C
      }]) => {
        var B, W;
        const O = (W = (B = a[o]) == null ? void 0 : B.palette) == null ? void 0 : W.mode, R = !r && O ? {
          colorScheme: O,
          ...C
        } : {
          ...C
        };
        w(n(o, {
          ...R
        }), R);
      }), v;
    }
  };
}
function Es(e) {
  return function(n) {
    return e === "media" ? `@media (prefers-color-scheme: ${n})` : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${n}"] &` : e === "class" ? `.${n} &` : e === "data" ? `[data-${n}] &` : `${e.replace("%s", n)} &` : "&";
  };
}
const ft = {
  black: "#000",
  white: "#fff"
}, _s = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Ve = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, He = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, it = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, Ge = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, qe = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, We = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
function hi() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: ft.white,
      default: ft.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const Ss = hi();
function yi() {
  return {
    text: {
      primary: ft.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: ft.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const Fr = yi();
function Mr(e, t, n, r) {
  const i = r.light || r, a = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = tr(e.main, i) : t === "dark" && (e.dark = er(e.main, a)));
}
function bs(e = "light") {
  return e === "dark" ? {
    main: Ge[200],
    light: Ge[50],
    dark: Ge[400]
  } : {
    main: Ge[700],
    light: Ge[400],
    dark: Ge[800]
  };
}
function vs(e = "light") {
  return e === "dark" ? {
    main: Ve[200],
    light: Ve[50],
    dark: Ve[400]
  } : {
    main: Ve[500],
    light: Ve[300],
    dark: Ve[700]
  };
}
function As(e = "light") {
  return e === "dark" ? {
    main: He[500],
    light: He[300],
    dark: He[700]
  } : {
    main: He[700],
    light: He[400],
    dark: He[800]
  };
}
function Cs(e = "light") {
  return e === "dark" ? {
    main: qe[400],
    light: qe[300],
    dark: qe[700]
  } : {
    main: qe[700],
    light: qe[500],
    dark: qe[900]
  };
}
function ws(e = "light") {
  return e === "dark" ? {
    main: We[400],
    light: We[300],
    dark: We[700]
  } : {
    main: We[800],
    light: We[500],
    dark: We[900]
  };
}
function Ts(e = "light") {
  return e === "dark" ? {
    main: it[400],
    light: it[300],
    dark: it[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: it[500],
    dark: it[900]
  };
}
function nr(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2,
    ...i
  } = e, a = e.primary || bs(t), s = e.secondary || vs(t), l = e.error || As(t), c = e.info || Cs(t), g = e.success || ws(t), p = e.warning || Ts(t);
  function d(h) {
    return cs(h, Fr.text.primary) >= n ? Fr.text.primary : Ss.text.primary;
  }
  const m = ({
    color: h,
    name: A,
    mainShade: S = 500,
    lightShade: x = 300,
    darkShade: v = 700
  }) => {
    if (h = {
      ...h
    }, !h.main && h[S] && (h.main = h[S]), !h.hasOwnProperty("main"))
      throw new Error(ze(11, A ? ` (${A})` : "", S));
    if (typeof h.main != "string")
      throw new Error(ze(12, A ? ` (${A})` : "", JSON.stringify(h.main)));
    return Mr(h, "light", x, r), Mr(h, "dark", v, r), h.contrastText || (h.contrastText = d(h.main)), h;
  };
  let y;
  return t === "light" ? y = hi() : t === "dark" && (y = yi()), ne({
    // A collection of common colors.
    common: {
      ...ft
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: m({
      color: a,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: m({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: m({
      color: l,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: m({
      color: p,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: m({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: m({
      color: g,
      name: "success"
    }),
    // The grey colors.
    grey: _s,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: d,
    // Generate a rich color object.
    augmentColor: m,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r,
    // The light and dark mode object.
    ...y
  }, i);
}
function xs(e) {
  const t = {};
  return Object.entries(e).forEach((r) => {
    const [i, a] = r;
    typeof a == "object" && (t[i] = `${a.fontStyle ? `${a.fontStyle} ` : ""}${a.fontVariant ? `${a.fontVariant} ` : ""}${a.fontWeight ? `${a.fontWeight} ` : ""}${a.fontStretch ? `${a.fontStretch} ` : ""}${a.fontSize || ""}${a.lineHeight ? `/${a.lineHeight} ` : ""}${a.fontFamily || ""}`);
  }), t;
}
function Is(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function ks(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Dr = {
  textTransform: "uppercase"
}, zr = '"Roboto", "Helvetica", "Arial", sans-serif';
function Ns(e, t) {
  const {
    fontFamily: n = zr,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: i = 300,
    fontWeightRegular: a = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: l = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: c = 16,
    // Apply the CSS properties to all the variants.
    allVariants: g,
    pxToRem: p,
    ...d
  } = typeof t == "function" ? t(e) : t, m = r / 14, y = p || ((A) => `${A / c * m}rem`), _ = (A, S, x, v, b) => ({
    fontFamily: n,
    fontWeight: A,
    fontSize: y(S),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: x,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === zr ? {
      letterSpacing: `${ks(v / S)}em`
    } : {},
    ...b,
    ...g
  }), h = {
    h1: _(i, 96, 1.167, -1.5),
    h2: _(i, 60, 1.2, -0.5),
    h3: _(a, 48, 1.167, 0),
    h4: _(a, 34, 1.235, 0.25),
    h5: _(a, 24, 1.334, 0),
    h6: _(s, 20, 1.6, 0.15),
    subtitle1: _(a, 16, 1.75, 0.15),
    subtitle2: _(s, 14, 1.57, 0.1),
    body1: _(a, 16, 1.5, 0.15),
    body2: _(a, 14, 1.43, 0.15),
    button: _(s, 14, 1.75, 0.4, Dr),
    caption: _(a, 12, 1.66, 0.4),
    overline: _(a, 12, 2.66, 1, Dr),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return ne({
    htmlFontSize: c,
    pxToRem: y,
    fontFamily: n,
    fontSize: r,
    fontWeightLight: i,
    fontWeightRegular: a,
    fontWeightMedium: s,
    fontWeightBold: l,
    ...h
  }, d, {
    clone: !1
    // No need to clone deep
  });
}
const Os = 0.2, Rs = 0.14, Ls = 0.12;
function X(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${Os})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${Rs})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${Ls})`].join(",");
}
const Ps = ["none", X(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), X(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), X(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), X(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), X(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), X(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), X(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), X(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), X(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), X(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), X(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), X(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), X(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), X(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), X(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), X(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), X(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), X(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), X(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), X(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), X(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), X(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), X(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), X(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], Bs = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Us = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Xr(e) {
  return `${Math.round(e)}ms`;
}
function Fs(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function Ms(e) {
  const t = {
    ...Bs,
    ...e.easing
  }, n = {
    ...Us,
    ...e.duration
  };
  return {
    getAutoHeightDuration: Fs,
    create: (i = ["all"], a = {}) => {
      const {
        duration: s = n.standard,
        easing: l = t.easeInOut,
        delay: c = 0,
        ...g
      } = a;
      return (Array.isArray(i) ? i : [i]).map((p) => `${p} ${typeof s == "string" ? s : Xr(s)} ${l} ${typeof c == "string" ? c : Xr(c)}`).join(",");
    },
    ...e,
    easing: t,
    duration: n
  };
}
const Ds = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function zs(e) {
  return Oe(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function Ei(e = {}) {
  const t = {
    ...e
  };
  function n(r) {
    const i = Object.entries(r);
    for (let a = 0; a < i.length; a++) {
      const [s, l] = i[a];
      !zs(l) || s.startsWith("unstable_") ? delete r[s] : Oe(l) && (r[s] = {
        ...l
      }, n(r[s]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function bn(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: r = {},
    spacing: i,
    palette: a = {},
    transitions: s = {},
    typography: l = {},
    shape: c,
    ...g
  } = e;
  if (e.vars)
    throw new Error(ze(20));
  const p = nr(a), d = fi(e);
  let m = ne(d, {
    mixins: Is(d.breakpoints, r),
    palette: p,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: Ps.slice(),
    typography: Ns(p, l),
    transitions: Ms(s),
    zIndex: {
      ...Ds
    }
  });
  return m = ne(m, g), m = t.reduce((y, _) => ne(y, _), m), m.unstable_sxConfig = {
    ...jt,
    ...g == null ? void 0 : g.unstable_sxConfig
  }, m.unstable_sx = function(_) {
    return Kt({
      sx: _,
      theme: this
    });
  }, m.toRuntimeSource = Ei, m;
}
function Xs(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const $s = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = Xs(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function _i(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function Si(e) {
  return e === "dark" ? $s : [];
}
function js(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: r,
    ...i
  } = e, a = nr(t);
  return {
    palette: a,
    opacity: {
      ..._i(a.mode),
      ...n
    },
    overlays: r || Si(a.mode),
    ...i
  };
}
function Ks(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const Vs = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], Hs = (e) => (t, n) => {
  const r = e.rootSelector || ":root", i = e.colorSchemeSelector;
  let a = i;
  if (i === "class" && (a = ".%s"), i === "data" && (a = "[data-%s]"), i != null && i.startsWith("data-") && !i.includes("%s") && (a = `[${i}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const s = {};
      return Vs(e.cssVarPrefix).forEach((l) => {
        s[l] = n[l], delete n[l];
      }), a === "media" ? {
        [r]: n,
        "@media (prefers-color-scheme: dark)": {
          [r]: s
        }
      } : a ? {
        [a.replace("%s", t)]: s,
        [`${r}, ${a.replace("%s", t)}`]: n
      } : {
        [r]: {
          ...n,
          ...s
        }
      };
    }
    if (a && a !== "media")
      return `${r}, ${a.replace("%s", String(t))}`;
  } else if (t) {
    if (a === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [r]: n
        }
      };
    if (a)
      return a.replace("%s", String(t));
  }
  return r;
};
function Gs(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function f(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function lt(e) {
  return !e || !e.startsWith("hsl") ? e : gi(e);
}
function Ce(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = st(lt(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function qs(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const Ee = (e) => {
  try {
    return e();
  } catch {
  }
}, Ws = (e = "mui") => fs(e);
function sn(e, t, n, r) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const i = r === "dark" ? "dark" : "light";
  if (!n) {
    e[r] = js({
      ...t,
      palette: {
        mode: i,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: a,
    ...s
  } = bn({
    ...n,
    palette: {
      mode: i,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[r] = {
    ...t,
    palette: a,
    opacity: {
      ..._i(i),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || Si(i)
  }, s;
}
function Ys(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: r,
    disableCssColorScheme: i = !1,
    cssVarPrefix: a = "mui",
    shouldSkipGeneratingVar: s = Ks,
    colorSchemeSelector: l = n.light && n.dark ? "media" : void 0,
    rootSelector: c = ":root",
    ...g
  } = e, p = Object.keys(n)[0], d = r || (n.light && p !== "light" ? "light" : p), m = Ws(a), {
    [d]: y,
    light: _,
    dark: h,
    ...A
  } = n, S = {
    ...A
  };
  let x = y;
  if ((d === "dark" && !("dark" in n) || d === "light" && !("light" in n)) && (x = !0), !x)
    throw new Error(ze(21, d));
  const v = sn(S, x, g, d);
  _ && !S.light && sn(S, _, void 0, "light"), h && !S.dark && sn(S, h, void 0, "dark");
  let b = {
    defaultColorScheme: d,
    ...v,
    cssVarPrefix: a,
    colorSchemeSelector: l,
    rootSelector: c,
    getCssVar: m,
    colorSchemes: S,
    font: {
      ...xs(v.typography),
      ...v.font
    },
    spacing: qs(g.spacing)
  };
  Object.keys(b.colorSchemes).forEach((L) => {
    const o = b.colorSchemes[L].palette, C = (O) => {
      const R = O.split("-"), B = R[1], W = R[2];
      return m(O, o[B][W]);
    };
    if (o.mode === "light" && (f(o.common, "background", "#fff"), f(o.common, "onBackground", "#000")), o.mode === "dark" && (f(o.common, "background", "#000"), f(o.common, "onBackground", "#fff")), Gs(o, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), o.mode === "light") {
      f(o.Alert, "errorColor", U(o.error.light, 0.6)), f(o.Alert, "infoColor", U(o.info.light, 0.6)), f(o.Alert, "successColor", U(o.success.light, 0.6)), f(o.Alert, "warningColor", U(o.warning.light, 0.6)), f(o.Alert, "errorFilledBg", C("palette-error-main")), f(o.Alert, "infoFilledBg", C("palette-info-main")), f(o.Alert, "successFilledBg", C("palette-success-main")), f(o.Alert, "warningFilledBg", C("palette-warning-main")), f(o.Alert, "errorFilledColor", Ee(() => o.getContrastText(o.error.main))), f(o.Alert, "infoFilledColor", Ee(() => o.getContrastText(o.info.main))), f(o.Alert, "successFilledColor", Ee(() => o.getContrastText(o.success.main))), f(o.Alert, "warningFilledColor", Ee(() => o.getContrastText(o.warning.main))), f(o.Alert, "errorStandardBg", F(o.error.light, 0.9)), f(o.Alert, "infoStandardBg", F(o.info.light, 0.9)), f(o.Alert, "successStandardBg", F(o.success.light, 0.9)), f(o.Alert, "warningStandardBg", F(o.warning.light, 0.9)), f(o.Alert, "errorIconColor", C("palette-error-main")), f(o.Alert, "infoIconColor", C("palette-info-main")), f(o.Alert, "successIconColor", C("palette-success-main")), f(o.Alert, "warningIconColor", C("palette-warning-main")), f(o.AppBar, "defaultBg", C("palette-grey-100")), f(o.Avatar, "defaultBg", C("palette-grey-400")), f(o.Button, "inheritContainedBg", C("palette-grey-300")), f(o.Button, "inheritContainedHoverBg", C("palette-grey-A100")), f(o.Chip, "defaultBorder", C("palette-grey-400")), f(o.Chip, "defaultAvatarColor", C("palette-grey-700")), f(o.Chip, "defaultIconColor", C("palette-grey-700")), f(o.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), f(o.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), f(o.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), f(o.LinearProgress, "primaryBg", F(o.primary.main, 0.62)), f(o.LinearProgress, "secondaryBg", F(o.secondary.main, 0.62)), f(o.LinearProgress, "errorBg", F(o.error.main, 0.62)), f(o.LinearProgress, "infoBg", F(o.info.main, 0.62)), f(o.LinearProgress, "successBg", F(o.success.main, 0.62)), f(o.LinearProgress, "warningBg", F(o.warning.main, 0.62)), f(o.Skeleton, "bg", `rgba(${C("palette-text-primaryChannel")} / 0.11)`), f(o.Slider, "primaryTrack", F(o.primary.main, 0.62)), f(o.Slider, "secondaryTrack", F(o.secondary.main, 0.62)), f(o.Slider, "errorTrack", F(o.error.main, 0.62)), f(o.Slider, "infoTrack", F(o.info.main, 0.62)), f(o.Slider, "successTrack", F(o.success.main, 0.62)), f(o.Slider, "warningTrack", F(o.warning.main, 0.62));
      const O = Nt(o.background.default, 0.8);
      f(o.SnackbarContent, "bg", O), f(o.SnackbarContent, "color", Ee(() => o.getContrastText(O))), f(o.SpeedDialAction, "fabHoverBg", Nt(o.background.paper, 0.15)), f(o.StepConnector, "border", C("palette-grey-400")), f(o.StepContent, "border", C("palette-grey-400")), f(o.Switch, "defaultColor", C("palette-common-white")), f(o.Switch, "defaultDisabledColor", C("palette-grey-100")), f(o.Switch, "primaryDisabledColor", F(o.primary.main, 0.62)), f(o.Switch, "secondaryDisabledColor", F(o.secondary.main, 0.62)), f(o.Switch, "errorDisabledColor", F(o.error.main, 0.62)), f(o.Switch, "infoDisabledColor", F(o.info.main, 0.62)), f(o.Switch, "successDisabledColor", F(o.success.main, 0.62)), f(o.Switch, "warningDisabledColor", F(o.warning.main, 0.62)), f(o.TableCell, "border", F(kt(o.divider, 1), 0.88)), f(o.Tooltip, "bg", kt(o.grey[700], 0.92));
    }
    if (o.mode === "dark") {
      f(o.Alert, "errorColor", F(o.error.light, 0.6)), f(o.Alert, "infoColor", F(o.info.light, 0.6)), f(o.Alert, "successColor", F(o.success.light, 0.6)), f(o.Alert, "warningColor", F(o.warning.light, 0.6)), f(o.Alert, "errorFilledBg", C("palette-error-dark")), f(o.Alert, "infoFilledBg", C("palette-info-dark")), f(o.Alert, "successFilledBg", C("palette-success-dark")), f(o.Alert, "warningFilledBg", C("palette-warning-dark")), f(o.Alert, "errorFilledColor", Ee(() => o.getContrastText(o.error.dark))), f(o.Alert, "infoFilledColor", Ee(() => o.getContrastText(o.info.dark))), f(o.Alert, "successFilledColor", Ee(() => o.getContrastText(o.success.dark))), f(o.Alert, "warningFilledColor", Ee(() => o.getContrastText(o.warning.dark))), f(o.Alert, "errorStandardBg", U(o.error.light, 0.9)), f(o.Alert, "infoStandardBg", U(o.info.light, 0.9)), f(o.Alert, "successStandardBg", U(o.success.light, 0.9)), f(o.Alert, "warningStandardBg", U(o.warning.light, 0.9)), f(o.Alert, "errorIconColor", C("palette-error-main")), f(o.Alert, "infoIconColor", C("palette-info-main")), f(o.Alert, "successIconColor", C("palette-success-main")), f(o.Alert, "warningIconColor", C("palette-warning-main")), f(o.AppBar, "defaultBg", C("palette-grey-900")), f(o.AppBar, "darkBg", C("palette-background-paper")), f(o.AppBar, "darkColor", C("palette-text-primary")), f(o.Avatar, "defaultBg", C("palette-grey-600")), f(o.Button, "inheritContainedBg", C("palette-grey-800")), f(o.Button, "inheritContainedHoverBg", C("palette-grey-700")), f(o.Chip, "defaultBorder", C("palette-grey-700")), f(o.Chip, "defaultAvatarColor", C("palette-grey-300")), f(o.Chip, "defaultIconColor", C("palette-grey-300")), f(o.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), f(o.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), f(o.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), f(o.LinearProgress, "primaryBg", U(o.primary.main, 0.5)), f(o.LinearProgress, "secondaryBg", U(o.secondary.main, 0.5)), f(o.LinearProgress, "errorBg", U(o.error.main, 0.5)), f(o.LinearProgress, "infoBg", U(o.info.main, 0.5)), f(o.LinearProgress, "successBg", U(o.success.main, 0.5)), f(o.LinearProgress, "warningBg", U(o.warning.main, 0.5)), f(o.Skeleton, "bg", `rgba(${C("palette-text-primaryChannel")} / 0.13)`), f(o.Slider, "primaryTrack", U(o.primary.main, 0.5)), f(o.Slider, "secondaryTrack", U(o.secondary.main, 0.5)), f(o.Slider, "errorTrack", U(o.error.main, 0.5)), f(o.Slider, "infoTrack", U(o.info.main, 0.5)), f(o.Slider, "successTrack", U(o.success.main, 0.5)), f(o.Slider, "warningTrack", U(o.warning.main, 0.5));
      const O = Nt(o.background.default, 0.98);
      f(o.SnackbarContent, "bg", O), f(o.SnackbarContent, "color", Ee(() => o.getContrastText(O))), f(o.SpeedDialAction, "fabHoverBg", Nt(o.background.paper, 0.15)), f(o.StepConnector, "border", C("palette-grey-600")), f(o.StepContent, "border", C("palette-grey-600")), f(o.Switch, "defaultColor", C("palette-grey-300")), f(o.Switch, "defaultDisabledColor", C("palette-grey-600")), f(o.Switch, "primaryDisabledColor", U(o.primary.main, 0.55)), f(o.Switch, "secondaryDisabledColor", U(o.secondary.main, 0.55)), f(o.Switch, "errorDisabledColor", U(o.error.main, 0.55)), f(o.Switch, "infoDisabledColor", U(o.info.main, 0.55)), f(o.Switch, "successDisabledColor", U(o.success.main, 0.55)), f(o.Switch, "warningDisabledColor", U(o.warning.main, 0.55)), f(o.TableCell, "border", U(kt(o.divider, 1), 0.68)), f(o.Tooltip, "bg", kt(o.grey[700], 0.92));
    }
    Ce(o.background, "default"), Ce(o.background, "paper"), Ce(o.common, "background"), Ce(o.common, "onBackground"), Ce(o, "divider"), Object.keys(o).forEach((O) => {
      const R = o[O];
      R && typeof R == "object" && (R.main && f(o[O], "mainChannel", st(lt(R.main))), R.light && f(o[O], "lightChannel", st(lt(R.light))), R.dark && f(o[O], "darkChannel", st(lt(R.dark))), R.contrastText && f(o[O], "contrastTextChannel", st(lt(R.contrastText))), O === "text" && (Ce(o[O], "primary"), Ce(o[O], "secondary")), O === "action" && (R.active && Ce(o[O], "active"), R.selected && Ce(o[O], "selected")));
    });
  }), b = t.reduce((L, o) => ne(L, o), b);
  const w = {
    prefix: a,
    disableCssColorScheme: i,
    shouldSkipGeneratingVar: s,
    getSelector: Hs(b)
  }, {
    vars: I,
    generateThemeVars: N,
    generateStyleSheets: k
  } = ys(b, w);
  return b.vars = I, Object.entries(b.colorSchemes[b.defaultColorScheme]).forEach(([L, o]) => {
    b[L] = o;
  }), b.generateThemeVars = N, b.generateStyleSheets = k, b.generateSpacing = function() {
    return pi(g.spacing, Qn(this));
  }, b.getColorSchemeSelector = Es(l), b.spacing = b.generateSpacing(), b.shouldSkipGeneratingVar = s, b.unstable_sxConfig = {
    ...jt,
    ...g == null ? void 0 : g.unstable_sxConfig
  }, b.unstable_sx = function(o) {
    return Kt({
      sx: o,
      theme: this
    });
  }, b.toRuntimeSource = Ei, b;
}
function $r(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: nr({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function Qs(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: r = !1,
    colorSchemes: i = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: a = n == null ? void 0 : n.mode,
    ...s
  } = e, l = a || "light", c = i == null ? void 0 : i[l], g = {
    ...i,
    ...n ? {
      [l]: {
        ...typeof c != "boolean" && c,
        palette: n
      }
    } : void 0
  };
  if (r === !1) {
    if (!("colorSchemes" in e))
      return bn(e, ...t);
    let p = n;
    "palette" in e || g[l] && (g[l] !== !0 ? p = g[l].palette : l === "dark" && (p = {
      mode: "dark"
    }));
    const d = bn({
      ...e,
      palette: p
    }, ...t);
    return d.defaultColorScheme = l, d.colorSchemes = g, d.palette.mode === "light" && (d.colorSchemes.light = {
      ...g.light !== !0 && g.light,
      palette: d.palette
    }, $r(d, "dark", g.dark)), d.palette.mode === "dark" && (d.colorSchemes.dark = {
      ...g.dark !== !0 && g.dark,
      palette: d.palette
    }, $r(d, "light", g.light)), d;
  }
  return !n && !("light" in g) && l === "light" && (g.light = !0), Ys({
    ...s,
    colorSchemes: g,
    defaultColorScheme: l,
    ...typeof r != "boolean" && r
  }, ...t);
}
const Js = Qs(), Zs = "$$material";
function el() {
  const e = is(Js);
  return e[Zs] || e;
}
const tl = (e) => e.scrollTop;
function jr(e, t) {
  const {
    timeout: n,
    easing: r,
    style: i = {}
  } = e;
  return {
    duration: i.transitionDuration ?? (typeof n == "number" ? n : n[t.mode] || 0),
    easing: i.transitionTimingFunction ?? (typeof r == "object" ? r[t.mode] : r),
    delay: i.transitionDelay
  };
}
const nl = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, dt = /* @__PURE__ */ T.forwardRef(function(t, n) {
  const r = el(), i = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    addEndListener: a,
    appear: s = !0,
    children: l,
    easing: c,
    in: g,
    onEnter: p,
    onEntered: d,
    onEntering: m,
    onExit: y,
    onExited: _,
    onExiting: h,
    style: A,
    timeout: S = i,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: x = Sa,
    ...v
  } = t, b = T.useRef(null), w = ps(b, to(l), n), I = (B) => (W) => {
    if (B) {
      const ge = b.current;
      W === void 0 ? B(ge) : B(ge, W);
    }
  }, N = I(m), k = I((B, W) => {
    tl(B);
    const ge = jr({
      style: A,
      timeout: S,
      easing: c
    }, {
      mode: "enter"
    });
    B.style.webkitTransition = r.transitions.create("opacity", ge), B.style.transition = r.transitions.create("opacity", ge), p && p(B, W);
  }), L = I(d), o = I(h), C = I((B) => {
    const W = jr({
      style: A,
      timeout: S,
      easing: c
    }, {
      mode: "exit"
    });
    B.style.webkitTransition = r.transitions.create("opacity", W), B.style.transition = r.transitions.create("opacity", W), y && y(B);
  }), O = I(_), R = (B) => {
    a && a(b.current, B);
  };
  return /* @__PURE__ */ Yo.jsx(x, {
    appear: s,
    in: g,
    nodeRef: b,
    onEnter: k,
    onEntered: L,
    onEntering: N,
    onExit: C,
    onExited: O,
    onExiting: o,
    addEndListener: R,
    timeout: S,
    ...v,
    children: (B, W) => /* @__PURE__ */ T.cloneElement(l, {
      style: {
        opacity: 0,
        visibility: B === "exited" && !g ? "hidden" : void 0,
        ...nl[B],
        ...A,
        ...l.props.style
      },
      ref: w,
      ...W
    })
  });
});
function rl(e) {
  return e && e.length ? e[0] : void 0;
}
var il = rl, al = il;
const bi = /* @__PURE__ */ ya(al), rr = /* @__PURE__ */ Gn({
  inMiniHeader: !1
}), Nd = ({
  children: e
}) => /* @__PURE__ */ u.createElement(rr.Provider, {
  value: {
    inMiniHeader: !0
  },
  "data-qa": "mini-header-indicator-context-provider"
}, e);
rr.displayName = "MiniHeaderIndicatorContext";
const ol = () => qn(rr), Od = () => {
  const {
    currentArticleId: e,
    rosettaInstance: t
  } = re();
  return {
    computeGA4CommonParameters: me(() => {
      var r;
      if (!t) return {};
      const a = (r = new URLSearchParams(window.location.search).get("promoCode")) !== null && r !== void 0 ? r : "";
      return {
        ...t.rulesEngine.getOutcome("tracking.ga4.baseParameters"),
        ...e ? {
          article_id: e
        } : {},
        ...a ? {
          promo_code: a
        } : {}
      };
    }, [e, t])
  };
}, sl = (e) => {
  const {
    handleTrackGA4: t
  } = re(), {
    inMiniHeader: n
  } = ol(), {
    ga4Event: r
  } = e, {
    captureTrackImpressionEventTargetElement: i,
    intersection: a
  } = wa({
    ga4TrackingHandler: t,
    getGa4Event: r,
    options: {
      intersectionThreshold: [0.5],
      isSendGA4Tracking: !n,
      shouldSendOnce: !0
    }
  });
  return {
    captureTrackImpressionEventTargetElement: i,
    intersection: a
  };
};
let M = /* @__PURE__ */ function(e) {
  return e.AcquisitionNewsletterPopup = "acquisition-newsletter-popup", e.Article = "article", e.Article20 = "article20", e.ArticleDark = "article-dark", e.Footer = "footer", e.Homepage = "homepage", e.LiveArticle = "live-article", e.NewsletterArticle = "newsletter-article", e.NewsletterArticleBottom = "newsletter-article-bottom", e.NewsletterList = "newsletter-list", e.Posties = "posties", e.Section = "section", e;
}({}), J = /* @__PURE__ */ function(e) {
  return e.FindOutMore = "find-out-more", e.SignUpNewsletter = "sign-up-newsletter", e.SignUpSuccessMessage = "sign-up-success-message", e;
}({});
const ir = /* @__PURE__ */ Gn({
  campaignName: "",
  dataMatrix: {},
  newsletterItems: [],
  queryParametersForSocialButtons: {},
  variant: M.Footer
}), ll = ({
  children: e,
  multipleNewsletters: t = !1,
  value: {
    newsletterItems: n,
    ...r
  }
}) => {
  const [i, a] = be(""), s = De(() => bi(n), [n]);
  return /* @__PURE__ */ u.createElement(ir.Provider, {
    value: {
      ...r,
      lastSubscribedNewsletter: i,
      newsletterItemForDisplay: s,
      newsletterItems: t ? n : n.slice(0, 1),
      setLastSubscribedNewsletter: a
    },
    "data-qa": "newsletter-context-provider"
  }, e);
};
ir.displayName = "NewsletterContext";
const fe = () => qn(ir), vi = /* @__PURE__ */ function() {
  var e = [{
    defaultValue: null,
    kind: "LocalArgument",
    name: "first"
  }, {
    defaultValue: null,
    kind: "LocalArgument",
    name: "newsletterIds"
  }], t = [{
    fields: [{
      kind: "Variable",
      name: "entityIds",
      variableName: "newsletterIds"
    }],
    kind: "ObjectValue",
    name: "filter"
  }, {
    kind: "Variable",
    name: "first",
    variableName: "first"
  }], n = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "entityId",
    storageKey: null
  }, r = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "name",
    storageKey: null
  }, i = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "alternativeName",
    storageKey: null
  }, a = [{
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "text",
    storageKey: null
  }], s = {
    alias: null,
    args: null,
    concreteType: "FormattedValue",
    kind: "LinkedField",
    name: "description",
    plural: !1,
    selections: a,
    storageKey: null
  }, l = {
    alias: null,
    args: null,
    concreteType: "FormattedValue",
    kind: "LinkedField",
    name: "summary",
    plural: !1,
    selections: a,
    storageKey: null
  }, c = {
    alias: null,
    args: null,
    concreteType: "FormattedValue",
    kind: "LinkedField",
    name: "homepageDescription",
    plural: !1,
    selections: a,
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: e,
      kind: "Fragment",
      metadata: null,
      name: "hooksNewsletterQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "NewsletterConnection",
        kind: "LinkedField",
        name: "newsletters",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "NewsletterEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "Newsletter",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [
              n,
              r,
              i,
              s,
              l,
              c
              /*: any*/
            ],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }],
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: e,
      kind: "Operation",
      name: "hooksNewsletterQuery",
      selections: [{
        alias: null,
        args: t,
        concreteType: "NewsletterConnection",
        kind: "LinkedField",
        name: "newsletters",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          concreteType: "NewsletterEdge",
          kind: "LinkedField",
          name: "edges",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            concreteType: "Newsletter",
            kind: "LinkedField",
            name: "node",
            plural: !1,
            selections: [n, r, i, s, l, c, {
              alias: null,
              args: null,
              kind: "ScalarField",
              name: "id",
              storageKey: null
            }],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }]
    },
    params: {
      cacheID: "db6ce7df57fd46a0894ca1c99f5593c8",
      id: null,
      metadata: {},
      name: "hooksNewsletterQuery",
      operationKind: "query",
      text: `query hooksNewsletterQuery(
  $first: Int
  $newsletterIds: [String]
) {
  newsletters(first: $first, filter: {entityIds: $newsletterIds}) {
    edges {
      node {
        entityId
        name
        alternativeName
        description {
          text
        }
        summary {
          text
        }
        homepageDescription {
          text
        }
        id
      }
    }
  }
}
`
    }
  };
}();
vi.hash = "07926024ff85778e6f495ad0f59ef656";
var Ai = { exports: {} }, ln = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kr;
function cl() {
  if (Kr) return ln;
  Kr = 1;
  var e = u;
  function t(d, m) {
    return d === m && (d !== 0 || 1 / d === 1 / m) || d !== d && m !== m;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, a = e.useLayoutEffect, s = e.useDebugValue;
  function l(d, m) {
    var y = m(), _ = r({ inst: { value: y, getSnapshot: m } }), h = _[0].inst, A = _[1];
    return a(function() {
      h.value = y, h.getSnapshot = m, c(h) && A({ inst: h });
    }, [d, y, m]), i(function() {
      return c(h) && A({ inst: h }), d(function() {
        c(h) && A({ inst: h });
      });
    }, [d]), s(y), y;
  }
  function c(d) {
    var m = d.getSnapshot;
    d = d.value;
    try {
      var y = m();
      return !n(d, y);
    } catch {
      return !0;
    }
  }
  function g(d, m) {
    return m();
  }
  var p = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? g : l;
  return ln.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : p, ln;
}
Ai.exports = cl();
var ul = Ai.exports;
const Re = () => {
}, ee = (
  /*#__NOINLINE__*/
  Re()
), cn = Object, P = (e) => e === ee, Se = (e) => typeof e == "function", Pe = (e, t) => ({
  ...e,
  ...t
}), dl = (e) => Se(e.then), Ot = /* @__PURE__ */ new WeakMap();
let ml = 0;
const gt = (e) => {
  const t = typeof e, n = e && e.constructor, r = n == Date;
  let i, a;
  if (cn(e) === e && !r && n != RegExp) {
    if (i = Ot.get(e), i) return i;
    if (i = ++ml + "~", Ot.set(e, i), n == Array) {
      for (i = "@", a = 0; a < e.length; a++)
        i += gt(e[a]) + ",";
      Ot.set(e, i);
    }
    if (n == cn) {
      i = "#";
      const s = cn.keys(e).sort();
      for (; !P(a = s.pop()); )
        P(e[a]) || (i += a + ":" + gt(e[a]) + ",");
      Ot.set(e, i);
    }
  } else
    i = r ? e.toJSON() : t == "symbol" ? e.toString() : t == "string" ? JSON.stringify(e) : "" + e;
  return i;
}, we = /* @__PURE__ */ new WeakMap(), un = {}, Rt = {}, ar = "undefined", Ht = typeof window != ar, vn = typeof document != ar, pl = () => Ht && typeof window.requestAnimationFrame != ar, Ci = (e, t) => {
  const n = we.get(e);
  return [
    // Getter
    () => !P(t) && e.get(t) || un,
    // Setter
    (r) => {
      if (!P(t)) {
        const i = e.get(t);
        t in Rt || (Rt[t] = i), n[5](t, Pe(i, r), i || un);
      }
    },
    // Subscriber
    n[6],
    // Get server cache snapshot
    () => !P(t) && t in Rt ? Rt[t] : !P(t) && e.get(t) || un
  ];
};
let An = !0;
const fl = () => An, [Cn, wn] = Ht && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  Re,
  Re
], gl = () => {
  const e = vn && document.visibilityState;
  return P(e) || e !== "hidden";
}, hl = (e) => (vn && document.addEventListener("visibilitychange", e), Cn("focus", e), () => {
  vn && document.removeEventListener("visibilitychange", e), wn("focus", e);
}), yl = (e) => {
  const t = () => {
    An = !0, e();
  }, n = () => {
    An = !1;
  };
  return Cn("online", t), Cn("offline", n), () => {
    wn("online", t), wn("offline", n);
  };
}, El = {
  isOnline: fl,
  isVisible: gl
}, _l = {
  initFocus: hl,
  initReconnect: yl
}, Vr = !u.useId, ht = !Ht || "Deno" in window, Sl = (e) => pl() ? window.requestAnimationFrame(e) : setTimeout(e, 1), dn = ht ? Ye : Ea, mn = typeof navigator < "u" && navigator.connection, Hr = !ht && mn && ([
  "slow-2g",
  "2g"
].includes(mn.effectiveType) || mn.saveData), or = (e) => {
  if (Se(e))
    try {
      e = e();
    } catch {
      e = "";
    }
  const t = e;
  return e = typeof e == "string" ? e : (Array.isArray(e) ? e.length : e) ? gt(e) : "", [
    e,
    t
  ];
};
let bl = 0;
const Tn = () => ++bl, wi = 0, Ti = 1, xi = 2, vl = 3;
var at = {
  __proto__: null,
  ERROR_REVALIDATE_EVENT: vl,
  FOCUS_EVENT: wi,
  MUTATE_EVENT: xi,
  RECONNECT_EVENT: Ti
};
async function Ii(...e) {
  const [t, n, r, i] = e, a = Pe({
    populateCache: !0,
    throwOnError: !0
  }, typeof i == "boolean" ? {
    revalidate: i
  } : i || {});
  let s = a.populateCache;
  const l = a.rollbackOnError;
  let c = a.optimisticData;
  const g = (m) => typeof l == "function" ? l(m) : l !== !1, p = a.throwOnError;
  if (Se(n)) {
    const m = n, y = [], _ = t.keys();
    for (const h of _)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test(h) && m(t.get(h)._k) && y.push(h);
    return Promise.all(y.map(d));
  }
  return d(n);
  async function d(m) {
    const [y] = or(m);
    if (!y) return;
    const [_, h] = Ci(t, y), [A, S, x, v] = we.get(t), b = () => {
      const R = A[y];
      return (Se(a.revalidate) ? a.revalidate(_().data, m) : a.revalidate !== !1) && (delete x[y], delete v[y], R && R[0]) ? R[0](xi).then(() => _().data) : _().data;
    };
    if (e.length < 3)
      return b();
    let w = r, I;
    const N = Tn();
    S[y] = [
      N,
      0
    ];
    const k = !P(c), L = _(), o = L.data, C = L._c, O = P(C) ? o : C;
    if (k && (c = Se(c) ? c(O, o) : c, h({
      data: c,
      _c: O
    })), Se(w))
      try {
        w = w(O);
      } catch (R) {
        I = R;
      }
    if (w && dl(w))
      if (w = await w.catch((R) => {
        I = R;
      }), N !== S[y][0]) {
        if (I) throw I;
        return w;
      } else I && k && g(I) && (s = !0, h({
        data: O,
        _c: ee
      }));
    if (s && !I)
      if (Se(s)) {
        const R = s(w, O);
        h({
          data: R,
          error: ee,
          _c: ee
        });
      } else
        h({
          data: w,
          error: ee,
          _c: ee
        });
    if (S[y][1] = Tn(), Promise.resolve(b()).then(() => {
      h({
        _c: ee
      });
    }), I) {
      if (p) throw I;
      return;
    }
    return w;
  }
}
const Gr = (e, t) => {
  for (const n in e)
    e[n][0] && e[n][0](t);
}, Al = (e, t) => {
  if (!we.has(e)) {
    const n = Pe(_l, t), r = {}, i = Ii.bind(ee, e);
    let a = Re;
    const s = {}, l = (p, d) => {
      const m = s[p] || [];
      return s[p] = m, m.push(d), () => m.splice(m.indexOf(d), 1);
    }, c = (p, d, m) => {
      e.set(p, d);
      const y = s[p];
      if (y)
        for (const _ of y)
          _(d, m);
    }, g = () => {
      if (!we.has(e) && (we.set(e, [
        r,
        {},
        {},
        {},
        i,
        c,
        l
      ]), !ht)) {
        const p = n.initFocus(setTimeout.bind(ee, Gr.bind(ee, r, wi))), d = n.initReconnect(setTimeout.bind(ee, Gr.bind(ee, r, Ti)));
        a = () => {
          p && p(), d && d(), we.delete(e);
        };
      }
    };
    return g(), [
      e,
      i,
      g,
      a
    ];
  }
  return [
    e,
    we.get(e)[4]
  ];
}, Cl = (e, t, n, r, i) => {
  const a = n.errorRetryCount, s = i.retryCount, l = ~~((Math.random() + 0.5) * (1 << (s < 8 ? s : 8))) * n.errorRetryInterval;
  !P(a) && s > a || setTimeout(r, l, i);
}, wl = (e, t) => gt(e) == gt(t), [ki, Tl] = Al(/* @__PURE__ */ new Map()), xl = Pe(
  {
    // events
    onLoadingSlow: Re,
    onSuccess: Re,
    onError: Re,
    onErrorRetry: Cl,
    onDiscarded: Re,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: Hr ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: Hr ? 5e3 : 3e3,
    // providers
    compare: wl,
    isPaused: () => !1,
    cache: ki,
    mutate: Tl,
    fallback: {}
  },
  // use web preset by default
  El
), Il = (e, t) => {
  const n = Pe(e, t);
  if (t) {
    const { use: r, fallback: i } = e, { use: a, fallback: s } = t;
    r && a && (n.use = r.concat(a)), i && s && (n.fallback = Pe(i, s));
  }
  return n;
}, kl = Gn({}), Nl = "$inf$", Ni = Ht && window.__SWR_DEVTOOLS_USE__, Ol = Ni ? window.__SWR_DEVTOOLS_USE__ : [], Rl = () => {
  Ni && (window.__SWR_DEVTOOLS_REACT__ = u);
}, Oi = (e) => Se(e[1]) ? [
  e[0],
  e[1],
  e[2] || {}
] : [
  e[0],
  null,
  (e[1] === null ? e[2] : e[1]) || {}
], Ll = () => Pe(xl, qn(kl)), Pl = (e) => (t, n, r) => e(t, n && ((...a) => {
  const [s] = or(t), [, , , l] = we.get(ki);
  if (s.startsWith(Nl))
    return n(...a);
  const c = l[s];
  return P(c) ? n(...a) : (delete l[s], c);
}), r), Bl = Ol.concat(Pl), Ul = (e) => function(...n) {
  const r = Ll(), [i, a, s] = Oi(n), l = Il(r, s);
  let c = e;
  const { use: g } = l, p = (g || []).concat(Bl);
  for (let d = p.length; d--; )
    c = p[d](c);
  return c(i, a || l.fetcher || null, l);
}, Fl = (e, t, n) => {
  const r = t[e] || (t[e] = []);
  return r.push(n), () => {
    const i = r.indexOf(n);
    i >= 0 && (r[i] = r[r.length - 1], r.pop());
  };
}, Ml = (e, t) => (...n) => {
  const [r, i, a] = Oi(n), s = (a.use || []).concat(t);
  return e(r, i, {
    ...a,
    use: s
  });
};
Rl();
const qr = u.use || ((e) => {
  if (e.status === "pending")
    throw e;
  if (e.status === "fulfilled")
    return e.value;
  throw e.status === "rejected" ? e.reason : (e.status = "pending", e.then((t) => {
    e.status = "fulfilled", e.value = t;
  }, (t) => {
    e.status = "rejected", e.reason = t;
  }), e);
}), pn = {
  dedupe: !0
}, Dl = (e, t, n) => {
  const { cache: r, compare: i, suspense: a, fallbackData: s, revalidateOnMount: l, revalidateIfStale: c, refreshInterval: g, refreshWhenHidden: p, refreshWhenOffline: d, keepPreviousData: m } = n, [y, _, h, A] = we.get(r), [S, x] = or(e), v = Me(!1), b = Me(!1), w = Me(S), I = Me(t), N = Me(n), k = () => N.current, L = () => k().isVisible() && k().isOnline(), [o, C, O, R] = Ci(r, S), B = Me({}).current, W = P(s) ? n.fallback[S] : s, ge = (D, z) => {
    for (const Q in B) {
      const V = Q;
      if (V === "data") {
        if (!i(D[V], z[V]) && (!P(D[V]) || !i(It, z[V])))
          return !1;
      } else if (z[V] !== D[V])
        return !1;
    }
    return !0;
  }, wt = De(() => {
    const D = !S || !t ? !1 : P(l) ? k().isPaused() || a ? !1 : P(c) ? !0 : c : l, z = (Z) => {
      const ve = Pe(Z);
      return delete ve._k, D ? {
        isValidating: !0,
        isLoading: !0,
        ...ve
      } : ve;
    }, Q = o(), V = R(), ye = z(Q), Ke = Q === V ? ye : z(V);
    let Y = ye;
    return [
      () => {
        const Z = z(o());
        return ge(Z, Y) ? (Y.data = Z.data, Y.isLoading = Z.isLoading, Y.isValidating = Z.isValidating, Y.error = Z.error, Y) : (Y = Z, Z);
      },
      () => Ke
    ];
  }, [
    r,
    S
  ]), ke = ul.useSyncExternalStore(me(
    (D) => O(S, (z, Q) => {
      ge(Q, z) || D();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r,
      S
    ]
  ), wt[0], wt[1]), Tt = !v.current, K = y[S] && y[S].length > 0, he = ke.data, Ne = P(he) ? W : he, xt = ke.error, Sr = Me(Ne), It = m ? P(he) ? Sr.current : he : Ne, br = K && !P(xt) ? !1 : Tt && !P(l) ? l : k().isPaused() ? !1 : a ? P(Ne) ? !1 : c : P(Ne) || c, vr = !!(S && t && Tt && br), pa = P(ke.isValidating) ? vr : ke.isValidating, fa = P(ke.isLoading) ? vr : ke.isLoading, nt = me(
    async (D) => {
      const z = I.current;
      if (!S || !z || b.current || k().isPaused())
        return !1;
      let Q, V, ye = !0;
      const Ke = D || {}, Y = !h[S] || !Ke.dedupe, Z = () => Vr ? !b.current && S === w.current && v.current : S === w.current, ve = {
        isValidating: !1,
        isLoading: !1
      }, Cr = () => {
        C(ve);
      }, wr = () => {
        const ie = h[S];
        ie && ie[1] === V && delete h[S];
      }, Tr = {
        isValidating: !0
      };
      P(o().data) && (Tr.isLoading = !0);
      try {
        if (Y && (C(Tr), n.loadingTimeout && P(o().data) && setTimeout(() => {
          ye && Z() && k().onLoadingSlow(S, n);
        }, n.loadingTimeout), h[S] = [
          z(x),
          Tn()
        ]), [Q, V] = h[S], Q = await Q, Y && setTimeout(wr, n.dedupingInterval), !h[S] || h[S][1] !== V)
          return Y && Z() && k().onDiscarded(S), !1;
        ve.error = ee;
        const ie = _[S];
        if (!P(ie) && // case 1
        (V <= ie[0] || // case 2
        V <= ie[1] || // case 3
        ie[1] === 0))
          return Cr(), Y && Z() && k().onDiscarded(S), !1;
        const Ae = o().data;
        ve.data = i(Ae, Q) ? Ae : Q, Y && Z() && k().onSuccess(Q, S, n);
      } catch (ie) {
        wr();
        const Ae = k(), { shouldRetryOnError: nn } = Ae;
        Ae.isPaused() || (ve.error = ie, Y && Z() && (Ae.onError(ie, S, Ae), (nn === !0 || Se(nn) && nn(ie)) && (!k().revalidateOnFocus || !k().revalidateOnReconnect || L()) && Ae.onErrorRetry(ie, S, Ae, (ga) => {
          const rn = y[S];
          rn && rn[0] && rn[0](at.ERROR_REVALIDATE_EVENT, ga);
        }, {
          retryCount: (Ke.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return ye = !1, Cr(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      S,
      r
    ]
  ), Ar = me(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...D) => Ii(r, w.current, ...D),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (dn(() => {
    I.current = t, N.current = n, P(he) || (Sr.current = he);
  }), dn(() => {
    if (!S) return;
    const D = nt.bind(ee, pn);
    let z = 0;
    const V = Fl(S, y, (ye, Ke = {}) => {
      if (ye == at.FOCUS_EVENT) {
        const Y = Date.now();
        k().revalidateOnFocus && Y > z && L() && (z = Y + k().focusThrottleInterval, D());
      } else if (ye == at.RECONNECT_EVENT)
        k().revalidateOnReconnect && L() && D();
      else {
        if (ye == at.MUTATE_EVENT)
          return nt();
        if (ye == at.ERROR_REVALIDATE_EVENT)
          return nt(Ke);
      }
    });
    return b.current = !1, w.current = S, v.current = !0, C({
      _k: x
    }), br && (P(Ne) || ht ? D() : Sl(D)), () => {
      b.current = !0, V();
    };
  }, [
    S
  ]), dn(() => {
    let D;
    function z() {
      const V = Se(g) ? g(o().data) : g;
      V && D !== -1 && (D = setTimeout(Q, V));
    }
    function Q() {
      !o().error && (p || k().isVisible()) && (d || k().isOnline()) ? nt(pn).then(z) : z();
    }
    return z(), () => {
      D && (clearTimeout(D), D = -1);
    };
  }, [
    g,
    p,
    d,
    S
  ]), _a(It), a && P(Ne) && S) {
    if (!Vr && ht)
      throw new Error("Fallback data is required when using suspense in SSR.");
    I.current = t, N.current = n, b.current = !1;
    const D = A[S];
    if (!P(D)) {
      const z = Ar(D);
      qr(z);
    }
    if (P(xt)) {
      const z = nt(pn);
      P(It) || (z.status = "fulfilled", z.value = !0), qr(z);
    } else
      throw xt;
  }
  return {
    mutate: Ar,
    get data() {
      return B.data = !0, It;
    },
    get error() {
      return B.error = !0, xt;
    },
    get isValidating() {
      return B.isValidating = !0, pa;
    },
    get isLoading() {
      return B.isLoading = !0, fa;
    }
  };
}, zl = Ul(Dl), Xl = (e) => (t, n, r) => (r.revalidateOnFocus = !1, r.revalidateIfStale = !1, r.revalidateOnReconnect = !1, e(t, n, r)), $l = Ml(zl, Xl), Ri = /* @__PURE__ */ function() {
  var e = [{
    defaultValue: null,
    kind: "LocalArgument",
    name: "input"
  }], t = [{
    kind: "Variable",
    name: "input",
    variableName: "input"
  }], n = {
    kind: "InlineFragment",
    selections: [{
      alias: null,
      args: null,
      concreteType: "SimplenewsSubscriberUid",
      kind: "LinkedField",
      name: "uid",
      plural: !1,
      selections: [{
        alias: null,
        args: null,
        concreteType: "SimplenewsSubscriberUidEntity",
        kind: "LinkedField",
        name: "entity",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          kind: "ScalarField",
          name: "uid",
          storageKey: null
        }],
        storageKey: null
      }],
      storageKey: null
    }, {
      alias: null,
      args: null,
      concreteType: "SimplenewsSubscriberSubscription",
      kind: "LinkedField",
      name: "subscriptions",
      plural: !0,
      selections: [{
        alias: null,
        args: null,
        concreteType: "SimplenewsSubscriberSubscriptionEntity",
        kind: "LinkedField",
        name: "entity",
        plural: !1,
        selections: [{
          alias: null,
          args: null,
          kind: "ScalarField",
          name: "entityId",
          storageKey: null
        }, {
          alias: null,
          args: null,
          kind: "ScalarField",
          name: "entityLabel",
          storageKey: null
        }],
        storageKey: null
      }],
      storageKey: null
    }],
    type: "SimplenewsSubscriber",
    abstractKey: null
  }, r = {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "errors",
    storageKey: null
  };
  return {
    fragment: {
      argumentDefinitions: e,
      kind: "Fragment",
      metadata: null,
      name: "apisSignUpNewslettersApiMutation",
      selections: [{
        alias: null,
        args: t,
        concreteType: "EntityCrudOutput",
        kind: "LinkedField",
        name: "upsertNewsletterSubscriber",
        plural: !1,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: null,
            kind: "LinkedField",
            name: "entity",
            plural: !1,
            selections: [
              n
              /*: any*/
            ],
            storageKey: null
          },
          r
          /*: any*/
        ],
        storageKey: null
      }],
      type: "Mutation",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: e,
      kind: "Operation",
      name: "apisSignUpNewslettersApiMutation",
      selections: [{
        alias: null,
        args: t,
        concreteType: "EntityCrudOutput",
        kind: "LinkedField",
        name: "upsertNewsletterSubscriber",
        plural: !1,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: null,
            kind: "LinkedField",
            name: "entity",
            plural: !1,
            selections: [
              {
                alias: null,
                args: null,
                kind: "ScalarField",
                name: "__typename",
                storageKey: null
              },
              n
              /*: any*/
            ],
            storageKey: null
          },
          r
          /*: any*/
        ],
        storageKey: null
      }]
    },
    params: {
      cacheID: "1fb3fb9786fa62f38926c967a5046b9b",
      id: null,
      metadata: {},
      name: "apisSignUpNewslettersApiMutation",
      operationKind: "mutation",
      text: `mutation apisSignUpNewslettersApiMutation(
  $input: NewsletterSubscriberInput
) {
  upsertNewsletterSubscriber(input: $input) {
    entity {
      __typename
      ... on SimplenewsSubscriber {
        uid {
          entity {
            uid
          }
        }
        subscriptions {
          entity {
            entityId
            entityLabel
          }
        }
      }
    }
    errors
  }
}
`
    }
  };
}();
Ri.hash = "9c5f8eda66218d275fb91bd0162382c4";
const Li = /* @__PURE__ */ function() {
  var e = [{
    alias: null,
    args: null,
    concreteType: "CurrentUserContext",
    kind: "LinkedField",
    name: "currentUserContext",
    plural: !1,
    selections: [{
      alias: null,
      args: null,
      concreteType: "ReverseUidSimplenewsSubscriber",
      kind: "LinkedField",
      name: "reverseUidSimplenewsSubscriber",
      plural: !1,
      selections: [{
        alias: null,
        args: null,
        concreteType: "SimplenewsSubscriber",
        kind: "LinkedField",
        name: "entities",
        plural: !0,
        selections: [{
          alias: null,
          args: null,
          concreteType: "SimplenewsSubscriberSubscription",
          kind: "LinkedField",
          name: "subscriptions",
          plural: !0,
          selections: [{
            alias: null,
            args: null,
            kind: "ScalarField",
            name: "status",
            storageKey: null
          }, {
            alias: null,
            args: null,
            concreteType: "SimplenewsSubscriberSubscriptionEntity",
            kind: "LinkedField",
            name: "entity",
            plural: !1,
            selections: [{
              alias: null,
              args: null,
              kind: "ScalarField",
              name: "entityId",
              storageKey: null
            }],
            storageKey: null
          }],
          storageKey: null
        }],
        storageKey: null
      }],
      storageKey: null
    }],
    storageKey: null
  }];
  return {
    fragment: {
      argumentDefinitions: [],
      kind: "Fragment",
      metadata: null,
      name: "apisSignupNewsletterQuery",
      selections: e,
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: [],
      kind: "Operation",
      name: "apisSignupNewsletterQuery",
      selections: e
      /*: any*/
    },
    params: {
      cacheID: "bee14d13a84d3a7ae570d06e18ab0d29",
      id: null,
      metadata: {},
      name: "apisSignupNewsletterQuery",
      operationKind: "query",
      text: `query apisSignupNewsletterQuery {
  currentUserContext {
    reverseUidSimplenewsSubscriber {
      entities {
        subscriptions {
          status
          entity {
            entityId
          }
        }
      }
    }
  }
}
`
    }
  };
}();
Li.hash = "9ef62adb5a9764d0efceaca536e80013";
const jl = Li, Kl = (e) => async () => {
  var t, n;
  const r = await ni(e, jl, {}).toPromise();
  return (t = r == null || (n = r.currentUserContext) === null || n === void 0 || (n = n.reverseUidSimplenewsSubscriber) === null || n === void 0 || (n = n.entities) === null || n === void 0 ? void 0 : n.flatMap((i) => {
    var a;
    return i == null || (a = i.subscriptions) === null || a === void 0 || (a = a.filter((s) => s == null ? void 0 : s.status)) === null || a === void 0 ? void 0 : a.map((s) => {
      var l;
      return s == null || (l = s.entity) === null || l === void 0 ? void 0 : l.entityId;
    });
  }).filter((i) => Je(i))) !== null && t !== void 0 ? t : [];
}, Vl = Ri, Hl = (e, t, n, r = {}) => {
  const i = t.map((a) => ({
    source: JSON.stringify(r),
    status: "1",
    targetId: a
  }));
  return new Promise((a) => {
    Ia(e, {
      mutation: Vl,
      onCompleted: (s) => {
        a(s.upsertNewsletterSubscriber);
      },
      variables: {
        input: {
          append: !0,
          mail: n,
          subscriptions: i
        }
      }
    });
  });
}, Gl = "subscription_newsletterItems", Pi = "subscription_dataMetrix", ql = vi, Bi = () => {
  const {
    environment: e,
    handleSetV1SignedUpNewslettersLocalStorage: t,
    user: n,
    v1SignedUpNewsletters: r
  } = re();
  e || console.error("Relay environment not found, make sure you wrapped your application with RelayEnvironmentProvider");
  const {
    set: i,
    value: a
  } = Lt(va, {
    defaultValue: 0
  }), {
    remove: s,
    value: l
  } = Lt(Pi, {
    defaultValue: {}
  }), c = me((A) => {
    n && i(Date.now()), t(A);
  }, [t, i, n]), g = () => Date.now() > ka(a ?? 0, 60).getTime(), {
    data: p,
    mutate: d
  } = $l(n ? Aa : null, Kl(e), {
    fallbackData: r,
    isPaused: () => !g(),
    onSuccess: (A) => c(A),
    refreshInterval: 1e3 * 30,
    revalidateOnMount: !0
  }), [m, y] = be(!1);
  Ye(() => {
    p && y(!0);
  }, [p]);
  const _ = me(async (A, S) => {
    const x = await ni(e, ql, {
      first: S,
      newsletterIds: A
    }).toPromise();
    return x == null ? void 0 : x.newsletters.edges.map(({
      node: v
    }) => {
      var b, w, I;
      return {
        alternativeName: v.alternativeName,
        description: (b = v.description) !== null && b !== void 0 && b.text ? {
          text: v.description.text
        } : void 0,
        entityId: v.entityId,
        homepageDescription: (w = v.homepageDescription) !== null && w !== void 0 && w.text ? {
          text: v.homepageDescription.text
        } : void 0,
        name: v.name,
        summary: (I = v.summary) !== null && I !== void 0 && I.text ? {
          text: v.summary.text
        } : void 0
      };
    });
  }, [e]), h = me(async (A, S, x) => {
    const v = !Je(x), b = await Hl(e, A, S, v ? l : x);
    if (Je(b.errors)) return b;
    const w = En(p ?? [], A, r);
    return await d(w, {
      optimisticData: w,
      populateCache: !0,
      revalidate: !1,
      rollbackOnError: !0
    }), v && s(), c(w), b;
  }, [p, l, e, c, d, s, r]);
  return {
    data: p,
    fetchNewsletterByIds: _,
    handleSignUpNewsletter: h,
    isDataReady: m,
    mutate: d
  };
}, Wl = () => {
  const {
    data: e
  } = Bi(), {
    v1SignedUpNewsletters: t
  } = re(), [n, r] = be(En(e ?? [], t ?? []));
  return Ye(() => {
    const i = setTimeout(() => r(En(e ?? [], t ?? [])), 1500);
    return () => clearTimeout(i);
  }, [e, t]), n;
}, Yl = (e) => e == null ? void 0 : e.name, xe = (e) => {
  switch (e) {
    case M.AcquisitionNewsletterPopup:
      return "ppto";
    case M.Article:
      return "article inline";
    case M.Footer:
      return "footer inline";
    case M.Homepage:
      return "homepage inline";
    case M.LiveArticle:
      return "article_side";
    case M.NewsletterArticle:
      return "newsletter article";
    case M.NewsletterArticleBottom:
      return "newsletter article";
    case M.NewsletterList:
      return "newsletter index";
    case M.Section:
      return "section inline";
  }
  return "newsletter index";
}, Ql = /* @__PURE__ */ E("img", {
  target: "e1expqve0"
})({
  name: "1f3tddi",
  styles: "inline-size:21px;block-size:18px"
});
function xn() {
  return xn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xn.apply(null, arguments);
}
const Jl = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAwCAYAAABE1blzAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAOKADAAQAAAABAAAAMAAAAAA9JyOSAAAC8klEQVRoBe2aOY/UQBSEBzaBhDvjEDcJvwAQGWzCnQMBQohLWuC3QMx9ZZtwCyEEJGQgEWzMAiE3AbuC+kZ+o2czPWaMPeMeXFJtv26321WuXu/O0WqlcVDdSXFa/BUZ0Yx2PPyBBRq5JcZmKqQXL3jq4Kqq0ORYx/HUmiPuFO/TSfBQ7QWRyGPCcok9Ie5wosep/da8oz6mYwXa74q2625i5I0b2MpA5Ngm/WYQb60ZN7CUgcixTPrN4MxcdcacIczGDu9hDIMhbA8dqNk4HtiWQVictAuTWVvU0uehsyIZq2OzSaJeiD/FzYnARWq9p1QHgzyJXrpJH1UfEesEUjsn/hDNzDPVaM81OF+TLrkTbYF7GlspDhsbJYDUTJe1aJ4n5hrUnDZ26ec70Rag/SQeFYcBUjsrfhe9Jv4hQavhrw1ywmLxsugXpH4grhIHBVJ7LmZ1oA2NHn0ZtBN3q8im+Vljx0T2fVUIpYYWNHVDIYMsxJ26Imbv4iONrRbLRig1NGRT89cubNAW2aMim+YXjR0Xy0iT1M6I2d+1Xqlpegf/bJCVlojdXmI91vgaJhTEBp3H4z67S7hWr9T85UoxaAvuVfFe9IK+qn9S7CfNUGqszY7pB6Ua5MKhNJ/o2Fom5KBXaqzdL0o3aAK6pflNB0+L3dLslRprFUVlBhHEHb8m+i1L/VRcLxpCqXFukdRsXdpKDdqF9qn4IHqjpDmRMPuEZC7nlIGBGEQoL56vi95kt5o5Zb7QHphB6W5jv35m08QoYxwrGwM3iAESuiFagtRlpqblOhiKQbv6ARWwSgzVYJXGbO2UQf4WjTQag7HH2yTYJFjzO9Bs0ZoHlCuvSTD3FtV8QpNgzQPKlfdfJDjrbsMoGPYeZulMOYPrXB1r6T1MYfC1czLh6lhL7+EV71eOi3y4abio4rz41gYiafmo/ZR42OnFWxu892/vl4xKi6cO+OLabXFUzOEl9WU8c3pIxaQ4LcZmFs1oT32d8jfZJ27pe+yPvgAAAABJRU5ErkJggg==", Zl = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAwCAYAAABE1blzAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAOKADAAQAAAABAAAAMAAAAAA9JyOSAAADTElEQVRoBe2auW+TQRDF46SBhpCEikvcNJRUENGBm5yAaLgKFCEuKcDfQhoaIAl3DeEQQghooAIpRWoSKCFcBYnM71keNF7yxTb+bLOWR3ra2fl2Z97zSyxwnGlzkcvljrM9DHaDte5RDOkcJN+C+5lMZtwIZ5QgbBXLVXBE+yaIu2gYQei8CZygcLQJhHkJkwg8lsG9A1QfuSdPyMfArKvFkK6D5Fmw35HN6sfzDrB4QJJ31R2KJhV38NDEsN6WwGlX2BuNmgSiaOl1eqYlcMEVehLuRVNGyxqnZ6Ed5h2O/YLLY029hg4JXDJ4FfYt+eA/K8KzHfQm0nJ2Ku3UQdY9hbredNYnXm7wA7jtBK/BL7CrwH01+Z+QGB+dbPRO9MYVP5OfarCWovHwkWuXwU9g8ZJE3EsKXMmh63bLrVPkG4omNWADhx1AroUhzivA8gKNMwf7wBzw8YXNiJ2p58pcuXYJ/AA+Ztn0GRfy8gTqAoe7wA0QxmMKG61prVdmybVXIQn24tbl57MvX6Bd5FI/CN2cp3Ya1OxfPvROck1c+o2fX6lXLlANuCg3x0EYTyls8kPSyOmZ5Jo4FLnm5/Hs3wRaExoMgNDNr9TOgKrdpIdcuwjC37VE14ybVu5VJ7DQpJtGEyCMZxQ2+4GV5NzdDvR2H4ZmJbrmZ3CueoHWkGaD4CPw8Y3NOVC2m5xNck29B2xeOSvn0xOogTRMcvM5z7aUIsWZ5VzrLnU/fJ66QBtA46Xc/E79AvjLTWrLuTZofStd6Zuug54AzeXmJAjjBYVtdpY8yTXdrdg166uV+7UTaIMYMgQ+AR9yc7SA8B1SZ4fsfjUrfWovUAQZ1ANuglKhM6n9R5te9RFoLjBwGIRuUsrXhu1cWit96ytQxBkqN28BC+WpueZfHPrWX6ARYPhBwfa1WBsqsBaCwp6hwMTPZMKLse5bAmN1zni3HLRXIta15WCszhnvloP2SsS6thyM1Tnj3XLQXolYVzm46Mg3g6New6I2M07gVpfHmnoNMxL43ikZdXmsqdfwTn8RzaJkyqm5Rn4FfHC1GFL9qf08OOnIZvMfyCKyab/KZb+Q+grUPac89lRapKmt6CN1nDxB7RBomq9T/gb9K0lQ38SgeAAAAABJRU5ErkJggg==", Ui = ({
  ...e
}) => {
  var t;
  const n = Bt();
  return /* @__PURE__ */ u.createElement(Ql, xn({}, e, {
    src: (n == null || (t = n.newsletterIcon) === null || t === void 0 ? void 0 : t.icon) === "black" ? Jl : Zl,
    "data-qa": "newsletter-icon"
  }));
};
Ui.displayName = "NewsletterIcon";
const sr = /* @__PURE__ */ E("div", {
  target: "e4lcx306"
})({
  name: "1xbksb9",
  styles: "display:flex;flex-flow:row;justify-content:space-between;align-items:center;margin-block:16px;margin-inline:0"
}), $e = /* @__PURE__ */ E("div", {
  target: "e4lcx305"
})("color:#000000;font-size:18px;font-family:", le, ";line-height:23px;", (e) => {
  var t;
  switch ((t = e.theme) === null || t === void 0 || (t = t.findOutMore) === null || t === void 0 ? void 0 : t.titleFontStyle) {
    case "large":
      return `
          font-size: 21px;
          line-height: 27px;
        `;
  }
}, ";"), lr = /* @__PURE__ */ E(Ui, {
  target: "e4lcx304"
})({
  name: "wb048k",
  styles: "inline-size:28px;block-size:24px"
}), Gt = /* @__PURE__ */ E("a", {
  target: "e4lcx303"
})(""), cr = /* @__PURE__ */ E("div", {
  target: "e4lcx302"
})(Gt, "{display:inline-block;inline-size:auto;color:#4585ff;font-size:14px;font-family:", H, ";line-height:16px;text-decoration:underline;cursor:pointer;}"), Fi = /* @__PURE__ */ E("div", {
  target: "e4lcx301"
})({
  name: "ip6zvp",
  styles: "inline-size:60px;block-size:1px;margin-block-end:28px;background-color:#001246"
}), je = /* @__PURE__ */ E("div", {
  target: "e4lcx300"
})('display:grid;grid-template-areas:"SummaryLine" "Icon" "Message" "Button";justify-items:center;text-align:center;', lr, "{grid-area:Icon;}", cr, "{grid-area:Button;}", sr, "{grid-area:Message;}", Fi, "{grid-area:SummaryLine;}");
function In() {
  return In = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, In.apply(null, arguments);
}
const Mi = ({
  ...e
}) => {
  const {
    handleRoutePush: t,
    handleTrackGA4: n
  } = re(), {
    campaignName: r,
    findOutMoreButtonDisplayComponent: i,
    variant: a
  } = fe(), s = Bt();
  return /* @__PURE__ */ u.createElement(je, In({}, e, {
    "data-qa": "find-out-more"
  }), (s == null ? void 0 : s.hasSummaryLine) && /* @__PURE__ */ u.createElement(Fi, null), /* @__PURE__ */ u.createElement(lr, null), /* @__PURE__ */ u.createElement(sr, null, /* @__PURE__ */ u.createElement($e, null, "Sign up for our Newsletters")), /* @__PURE__ */ u.createElement(cr, null, /* @__PURE__ */ u.createElement(Gt, {
    href: "/newsletters",
    onClick: (l) => {
      l.preventDefault(), n({
        action: "click",
        category: "nl",
        customized_parameters: {
          internal_campaign: r ?? "",
          trigger_point: xe(a)
        },
        subcategory: "entry"
      }), t("/newsletters");
    }
  }, i ?? "Find out more")));
};
Mi.displayName = "FindOutMore";
var ur = {}, Di = { exports: {} };
/*! js-cookie v3.0.5 | MIT */
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(yn, function() {
    function n(s) {
      for (var l = 1; l < arguments.length; l++) {
        var c = arguments[l];
        for (var g in c)
          s[g] = c[g];
      }
      return s;
    }
    var r = {
      read: function(s) {
        return s[0] === '"' && (s = s.slice(1, -1)), s.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
      },
      write: function(s) {
        return encodeURIComponent(s).replace(
          /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
          decodeURIComponent
        );
      }
    };
    function i(s, l) {
      function c(p, d, m) {
        if (!(typeof document > "u")) {
          m = n({}, l, m), typeof m.expires == "number" && (m.expires = new Date(Date.now() + m.expires * 864e5)), m.expires && (m.expires = m.expires.toUTCString()), p = encodeURIComponent(p).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
          var y = "";
          for (var _ in m)
            m[_] && (y += "; " + _, m[_] !== !0 && (y += "=" + m[_].split(";")[0]));
          return document.cookie = p + "=" + s.write(d, p) + y;
        }
      }
      function g(p) {
        if (!(typeof document > "u" || arguments.length && !p)) {
          for (var d = document.cookie ? document.cookie.split("; ") : [], m = {}, y = 0; y < d.length; y++) {
            var _ = d[y].split("="), h = _.slice(1).join("=");
            try {
              var A = decodeURIComponent(_[0]);
              if (m[A] = s.read(h, A), p === A)
                break;
            } catch {
            }
          }
          return p ? m[p] : m;
        }
      }
      return Object.create(
        {
          set: c,
          get: g,
          remove: function(p, d) {
            c(
              p,
              "",
              n({}, d, {
                expires: -1
              })
            );
          },
          withAttributes: function(p) {
            return i(this.converter, n({}, this.attributes, p));
          },
          withConverter: function(p) {
            return i(n({}, this.converter, p), this.attributes);
          }
        },
        {
          attributes: { value: Object.freeze(l) },
          converter: { value: Object.freeze(s) }
        }
      );
    }
    var a = i(r, { path: "/" });
    return a;
  });
})(Di);
var ec = Di.exports, qt = {};
Object.defineProperty(qt, "__esModule", { value: !0 });
qt.useFirstMountState = void 0;
const Wr = u;
function tc() {
  const e = (0, Wr.useRef)(!0);
  return (0, Wr.useEffect)(() => {
    e.current = !1;
  }, []), e.current;
}
qt.useFirstMountState = tc;
var Wt = {};
Object.defineProperty(Wt, "__esModule", { value: !0 });
Wt.useMountEffect = void 0;
const nc = u;
function rc(e) {
  (0, nc.useEffect)(() => {
    e();
  }, []);
}
Wt.useMountEffect = rc;
var Yt = {};
Object.defineProperty(Yt, "__esModule", { value: !0 });
Yt.useSyncedRef = void 0;
const Yr = u;
function ic(e) {
  const t = (0, Yr.useRef)(e);
  return t.current = e, (0, Yr.useMemo)(() => Object.freeze({
    get current() {
      return t.current;
    }
  }), []);
}
Yt.useSyncedRef = ic;
var oe = {};
Object.defineProperty(oe, "__esModule", { value: !0 });
oe.truthyOrArrayPredicate = oe.truthyAndArrayPredicate = oe.isStrictEqual = oe.isBrowser = oe.noop = void 0;
const ac = () => {
};
oe.noop = ac;
oe.isBrowser = typeof window < "u" && typeof navigator < "u" && typeof document < "u";
const oc = (e, t) => e === t;
oe.isStrictEqual = oc;
const sc = (e) => e.every(Boolean);
oe.truthyAndArrayPredicate = sc;
const lc = (e) => e.some(Boolean);
oe.truthyOrArrayPredicate = lc;
var cc = yn && yn.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ur, "__esModule", { value: !0 });
var dr = ur.useCookieValue = void 0;
const fn = cc(ec), ot = u, uc = qt, dc = Wt, mc = Yt, pc = oe, yt = /* @__PURE__ */ new Map(), fc = (e, t) => {
  let n = yt.get(e);
  n || (n = /* @__PURE__ */ new Set(), yt.set(e, n)), n.add(t);
}, gc = (e, t) => {
  const n = yt.get(e);
  n && (n.delete(t), n.size || yt.delete(e));
}, gn = (e, t, n) => {
  const r = yt.get(e);
  r && r.forEach((i) => {
    i !== n && i(t);
  });
};
function hc(e, t = {}) {
  let { initializeWithValue: n = !0, ...r } = t;
  pc.isBrowser || (n = !1);
  const i = (0, mc.useSyncedRef)({
    set(c) {
      l(c), fn.default.set(e, c, r), gn(e, c, l);
    },
    remove() {
      l(null), fn.default.remove(e, r), gn(e, null, l);
    },
    fetchVal: () => fn.default.get(e) ?? null,
    fetch() {
      const c = i.current.fetchVal();
      l(c), gn(e, c, l);
    }
  }), a = (0, uc.useFirstMountState)(), [s, l] = (0, ot.useState)(a && n ? i.current.fetchVal() : void 0);
  return (0, dc.useMountEffect)(() => {
    n || i.current.fetch();
  }), (0, ot.useEffect)(() => (fc(e, l), () => {
    gc(e, l);
  }), [e]), [
    s,
    (0, ot.useCallback)((c) => {
      i.current.set(c);
    }, []),
    (0, ot.useCallback)(() => {
      i.current.remove();
    }, []),
    (0, ot.useCallback)(() => {
      i.current.fetch();
    }, [])
  ];
}
dr = ur.useCookieValue = hc;
const yc = "Please enter a valid email address", Ec = "There was a problem. Please try again", hn = "";
function _c(e) {
  return /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z\-]+\.)+[A-Za-z]{2,}))$/.test(e);
}
const Sc = /* @__PURE__ */ E("span", {
  target: "ek9223x1"
})({
  name: "34b66o",
  styles: '::after{content:"";display:inline-block;animation:dotty steps(1, end) 2s infinite;}@keyframes dotty{0%{content:"";}25%{content:".";}50%{content:"..";}75%{content:"...";}100%{content:"";}}'
});
var bc = {
  name: "c0yhd0",
  styles: "min-inline-size:82px"
}, vc = {
  name: "1nw19os",
  styles: "min-inline-size:244px"
};
const Ue = /* @__PURE__ */ E("button", {
  target: "ek9223x0"
})("block-size:35px;min-inline-size:86px;color:#ffffff;font-size:14px;line-height:16px;border:0;border-radius:2px;background-color:#4585ff;cursor:pointer;", (e) => {
  switch (e.$buttonSize) {
    case "large":
      return vc;
    case "small":
      return bc;
  }
}, ";");
function kn() {
  return kn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kn.apply(null, arguments);
}
const mr = ({
  children: e,
  isLoading: t,
  onClick: n,
  size: r = "medium",
  ...i
}) => {
  const a = (s) => {
    t || n(s);
  };
  return /* @__PURE__ */ u.createElement(Ue, kn({}, i, {
    $buttonSize: r,
    onClick: a,
    "data-qa": "sign-up-button"
  }), t ? /* @__PURE__ */ u.createElement(Sc, null, "SENDING") : /* @__PURE__ */ u.createElement("span", null, e));
};
mr.displayName = "SignUpButton";
const Ac = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 17, viewBox: "0 0 17 17", ...e }, /* @__PURE__ */ T.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ T.createElement("path", { d: "M21-4H-3v24h24z" }), /* @__PURE__ */ T.createElement("path", { d: "M17 8.177H.875m8-8l-8 8 8 8", stroke: "#FEFEFE" }))), et = /* @__PURE__ */ E(Ac, {
  target: "e1kldszr7"
})({
  name: "gz16y9",
  styles: "path{stroke:#4585ff;}"
}), Cc = /* @__PURE__ */ E("div", {
  target: "e1kldszr6"
})({
  name: "ebvuqd",
  styles: "display:flex;flex-flow:row;justify-content:stretch;align-items:center;margin-inline-end:12px;cursor:pointer"
}), zi = /* @__PURE__ */ E("input", {
  target: "e1kldszr5"
})("inline-size:100%;block-size:35px;padding-inline-start:10px;color:#000000;font-size:16px;font-family:", H, ";border:1px solid #d7d7d7;border-color:", (e) => e.$isError ? "#eb4254" : "#d7d7d7", ";border-radius:2px;&::placeholder{color:#999999;}"), wc = /* @__PURE__ */ E("div", {
  target: "e1kldszr4"
})("margin-block:2px 0;margin-inline:2px 0;color:#eb4254;font-size:10px;font-family:", H, ";line-height:11px;"), Tc = /* @__PURE__ */ E("div", {
  target: "e1kldszr3"
})({
  name: "1ckj6g",
  styles: "margin-inline-end:8px"
}), xc = /* @__PURE__ */ E("form", {
  target: "e1kldszr2"
})({
  name: "zjik7",
  styles: "display:flex"
}), Ic = /* @__PURE__ */ E("div", {
  target: "e1kldszr1"
})({
  name: "zjik7",
  styles: "display:flex"
}), Qt = /* @__PURE__ */ E(mr, {
  target: "e1kldszr0"
})("");
function Nn() {
  return Nn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nn.apply(null, arguments);
}
const Xi = ({
  onPreviousClick: e,
  onSubmit: t,
  ...n
}) => {
  const [r, i] = be(""), [a, s] = be(hn), [l, c] = be(!1), {
    executeRecaptcha: g
  } = Ua(), p = async () => {
    if (!_c(r)) {
      s(yc);
      return;
    }
    c(!0);
    const d = await (g == null ? void 0 : g());
    if (!d) return;
    s(hn);
    const m = await t({
      email: r,
      recaptchaToken: d
    });
    m != null && m.error && (s(Ec), c(!1));
  };
  return /* @__PURE__ */ u.createElement(Ic, Nn({}, n, {
    "data-qa": "email-form"
  }), /* @__PURE__ */ u.createElement(Cc, null, /* @__PURE__ */ u.createElement(et, {
    height: "15",
    onClick: e,
    width: "15"
  })), /* @__PURE__ */ u.createElement(xc, {
    method: "post",
    onSubmit: (d) => {
      d.preventDefault(), p();
    }
  }, /* @__PURE__ */ u.createElement(Tc, null, /* @__PURE__ */ u.createElement(zi, {
    $isError: !!a,
    onChange: (d) => {
      d.target.value || s(hn), i(d.target.value);
    },
    placeholder: "Email",
    value: r
  }), a && /* @__PURE__ */ u.createElement(wc, null, a)), /* @__PURE__ */ u.createElement(Qt, {
    isLoading: l,
    onClick: (d) => {
      d.preventDefault(), p();
    }
  }, "SIGN UP")));
};
Xi.displayName = "EmailForm";
let q = /* @__PURE__ */ function(e) {
  return e.EmailForm = "email-form", e.OverlaySignUpButton = "overlay-sign-up-button", e.SignUpButton = "sign-up-button", e.SocialButtons = "social-buttons", e;
}({}), On = /* @__PURE__ */ function(e) {
  return e.Email = "email", e.Facebook = "facebook", e.Google = "google", e;
}({});
const kc = () => {
  const {
    config: e
  } = re();
  return {
    getSocialLoginUrl: (n, r, i) => {
      const a = new URL(e.accounts.host), s = new URL(location.href);
      s.search = xr.stringify(r);
      const {
        triggerPoint: l,
        ...c
      } = r, g = new URL(location.href);
      return g.search = xr.stringify(c), a.searchParams.set("callback", g.toString()), a.searchParams.set("destination", s.toString()), a.searchParams.set("nonce", ""), a.searchParams.set("optIn", i ? "true" : "false"), a.searchParams.set("triggerPoint", l), a.pathname = `/login/${n}`, a.toString();
    }
  };
}, Nc = (e) => /* @__PURE__ */ T.createElement("svg", { width: 22, height: 19, viewBox: "0 0 22 19", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M22 7.548v9.1c0 1.15-.99 2.09-2.2 2.09H2.2c-1.21 0-2.2-.94-2.2-2.09l.007-9.1 11.026 4.635L22 7.548zM19.8.738c1.21 0 2.2.94 2.2 2.089v3.332l-10.968 4.669L.008 6.16l.003-3.333c0-1.1.896-2.007 2.033-2.084L2.2.738z", fill: "#AAA" })), Oc = (e) => /* @__PURE__ */ T.createElement("svg", { width: 22, height: 23, viewBox: "0 0 22 23", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M22 11.805C22 5.692 17.075.738 11 .738S0 5.692 0 11.805c0 5.524 4.023 10.102 9.281 10.933v-7.734H6.488v-3.2h2.793V9.367c0-2.773 1.642-4.305 4.155-4.305 1.204 0 2.462.216 2.462.216V8h-1.387c-1.366 0-1.792.853-1.792 1.729v2.076h3.05l-.487 3.199h-2.563v7.734c5.258-.83 9.281-5.41 9.281-10.933", fill: "#1977F2", fillRule: "evenodd" })), Rc = (e) => /* @__PURE__ */ T.createElement("svg", { width: 22, height: 23, viewBox: "0 0 22 23", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ T.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ T.createElement("path", { d: "M21.168 11.783c0-.766-.069-1.502-.196-2.21H10.8v4.179h5.812a4.968 4.968 0 0 1-2.155 3.26v2.709h3.49c2.043-1.88 3.221-4.649 3.221-7.938z", fill: "#4285F4", fillRule: "nonzero" }), /* @__PURE__ */ T.createElement("path", { d: "M10.8 22.338c2.916 0 5.36-.968 7.148-2.617l-3.49-2.71c-.968.648-2.205 1.031-3.658 1.031-2.813 0-5.194-1.9-6.043-4.452H1.149v2.798a10.796 10.796 0 0 0 9.651 5.95z", fill: "#34A853", fillRule: "nonzero" }), /* @__PURE__ */ T.createElement("path", { d: "M4.757 13.59a6.492 6.492 0 0 1-.339-2.052c0-.712.123-1.404.339-2.052V6.687H1.149A10.796 10.796 0 0 0 0 11.537c0 1.743.417 3.393 1.149 4.85l3.608-2.797z", fill: "#FBBC05", fillRule: "nonzero" }), /* @__PURE__ */ T.createElement("path", { d: "M10.8 5.033c1.586 0 3.01.545 4.129 1.615l3.097-3.098C16.156 1.808 13.711.738 10.8.738c-4.222 0-7.874 2.42-9.651 5.95l3.608 2.798c.85-2.553 3.23-4.453 6.043-4.453z", fill: "#EA4335", fillRule: "nonzero" }), /* @__PURE__ */ T.createElement("path", { d: "M0 .738h21.6v21.6H0z" }))), se = /* @__PURE__ */ E("div", {
  target: "e1uwm9yr1"
})({
  name: "1qitn38",
  styles: "display:flex;flex-flow:row;justify-content:center;align-items:center;inline-size:52px;block-size:35px;margin-inline-end:12px;box-sizing:border-box;border:1px solid #d7d7d7;border-radius:2px;background:#000000;cursor:pointer"
}), pr = /* @__PURE__ */ E("div", {
  target: "e1uwm9yr0"
})({
  name: "1nb6kt7",
  styles: "display:flex;flex-flow:row;justify-content:flex-start;align-items:center"
});
function Rn() {
  return Rn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rn.apply(null, arguments);
}
const $i = ({
  isAgreedReceiveMarketing: e,
  onEmailClick: t,
  ...n
}) => {
  const {
    campaignName: r,
    dataMatrix: i,
    newsletterItems: a,
    queryParametersForSocialButtons: s,
    variant: l
  } = fe(), {
    getSocialLoginUrl: c
  } = kc(), {
    handleRoutePush: g,
    handleTrackGA4: p
  } = re(), {
    set: d
  } = Lt(Gl), {
    set: m
  } = Lt(Pi), y = (h) => {
    var A, S;
    d(a), m(i), p({
      action: "click",
      category: "nl",
      customized_parameters: {
        method: h,
        newsletter_name: (A = a[0].name) !== null && A !== void 0 ? A : "",
        trigger_point: xe(l)
      },
      subcategory: "sign_up"
    });
    const x = a.filter((v) => v.entityId).map((v) => v.entityId);
    g(c(h, {
      campaignName: r,
      newsletterIds: x,
      newsletterName: (S = a[0].name) !== null && S !== void 0 ? S : "",
      subscription: "true",
      triggerPoint: xe(l),
      variant: l
    }, e), {
      query: s
    });
  }, _ = De(() => Na(), []);
  return /* @__PURE__ */ u.createElement(pr, Rn({}, n, {
    "data-qa": "social-buttons"
  }), /* @__PURE__ */ u.createElement(se, {
    onClick: () => y(On.Facebook)
  }, /* @__PURE__ */ u.createElement(Oc, {
    height: "100%",
    width: "22"
  })), !_ && /* @__PURE__ */ u.createElement(se, {
    onClick: () => y(On.Google)
  }, /* @__PURE__ */ u.createElement(Rc, {
    height: "100%",
    width: "22"
  })), /* @__PURE__ */ u.createElement(se, {
    onClick: t
  }, /* @__PURE__ */ u.createElement(Nc, {
    height: "100%",
    width: "22"
  })));
};
$i.displayName = "SocialButtons";
const ji = /* @__PURE__ */ E(mr, {
  target: "e1e053fq14"
})(""), fr = /* @__PURE__ */ E("div", {
  target: "e1e053fq13"
})({
  name: "e0dnmk",
  styles: "cursor:pointer"
}), Be = /* @__PURE__ */ E("div", {
  target: "e1e053fq12"
})("max-inline-size:254px;margin-inline-end:8px;color:#666666;font-size:11px;font-family:", H, ";line-height:13px;"), Et = /* @__PURE__ */ E("div", {
  target: "e1e053fq11"
})("grid-area:Agreement;display:flex;margin-block-end:12px;", (e) => e.theme.breakpoints.up("tablet"), "{margin-block-end:", (e) => {
  var t;
  return ((t = e.theme) === null || t === void 0 ? void 0 : t.orientation) === "landscape" ? "0" : "12px";
}, ";}:empty{margin-block-end:0;}"), Lc = /* @__PURE__ */ E("div", {
  target: "e1e053fq10"
})({
  name: "1501yv5",
  styles: "grid-area:Description;margin-block:4px 10px"
}), Pc = /* @__PURE__ */ E("div", {
  target: "e1e053fq9"
})("font-size:14px;font-family:", le, ";line-height:19px;"), Jt = /* @__PURE__ */ E("div", {
  target: "e1e053fq8"
})({
  name: "110j674",
  styles: "grid-area:Summary;margin-block-end:4px"
});
var Bc = {
  name: "1b6c22i",
  styles: "font-size:11px;line-height:13px"
};
const Zt = /* @__PURE__ */ E("div", {
  target: "e1e053fq7"
})("color:#222222;font-size:12px;font-family:", H, ";line-height:14px;text-align:center;text-transform:uppercase;", (e) => {
  var t;
  switch ((t = e.theme) === null || t === void 0 || (t = t.signUpNewsletter) === null || t === void 0 ? void 0 : t.summaryFontStyle) {
    case "small":
      return Bc;
  }
}, ";");
var Uc = {
  name: "1vu3ru",
  styles: "font-size:15px;line-height:19px"
}, Fc = {
  name: "11tjyy3",
  styles: "font-size:21px;line-height:27px"
}, Mc = {
  name: "wh4tv7",
  styles: "font-weight:300;font-size:21px;font-style:italic;line-height:27px"
};
const pe = /* @__PURE__ */ E("div", {
  target: "e1e053fq6"
})("color:#000000;font-size:18px;font-family:", le, ";line-height:23px;", (e) => {
  var t;
  switch ((t = e.theme) === null || t === void 0 || (t = t.signUpNewsletter) === null || t === void 0 ? void 0 : t.titleFontStyle) {
    case "italic-large":
      return Mc;
    case "large":
      return Fc;
    case "small":
      return Uc;
  }
}, ";"), _t = /* @__PURE__ */ E("div", {
  target: "e1e053fq5"
})({
  name: "1wl4b09",
  styles: "grid-area:Title;margin-block-end:8px"
}), Ze = /* @__PURE__ */ E("div", {
  target: "e1e053fq4"
})({
  name: "cfcqlx",
  styles: "grid-area:Action;margin-block-end:10px"
}), St = /* @__PURE__ */ E("a", {
  target: "e1e053fq3"
})({
  name: "4dv4e3",
  styles: "margin-block:0;margin-inline:2px"
}), en = /* @__PURE__ */ E("div", {
  target: "e1e053fq2"
})("grid-area:TermAndCondition;color:#999999;font-size:10px;font-family:", H, ";line-height:11px;", St, "{color:#999999;text-decoration:underline;}"), Dc = /* @__PURE__ */ E("div", {
  target: "e1e053fq1"
})({
  name: "10rfpyb",
  styles: "grid-area:SummaryLine;inline-size:60px;block-size:1px;margin-block-end:16px;background-color:#001246"
});
var zc = {
  name: "1y77c6w",
  styles: 'grid-template-areas:"SummaryLine" "Summary" "Title" "Description" "Agreement" "Action" "TermAndCondition";justify-items:center;text-align:center'
}, Xc = {
  name: "1wz5quw",
  styles: 'grid-template-areas:"SummaryLine Action" "Summary Action" "Title Action" "Description Action" "Agreement TermAndCondition";grid-template-rows:repeat(5, minmax(0, min-content));justify-items:center;text-align:center;column-gap:20px'
};
const ce = /* @__PURE__ */ E("div", {
  target: "e1e053fq0"
})('display:grid;grid-template-areas:"SummaryLine" "Summary" "Title" "Description" "Agreement" "Action" "TermAndCondition";grid-template-rows:repeat(7, minmax(0, min-content));justify-items:center;color:#ffffff;text-align:center;', (e) => e.theme.breakpoints.up("tablet"), "{", (e) => {
  var t;
  return ((t = e.theme) === null || t === void 0 ? void 0 : t.orientation) === "landscape" ? Xc : zc;
}, ";}"), $c = () => {
  const {
    campaignName: e,
    dataMatrix: t,
    newsletterItems: n,
    variant: r
  } = fe(), {
    config: i,
    handleTrackGA4: a,
    handleTrackGTM: s,
    handleTrackMirror: l,
    user: c
  } = re(), {
    handleSignUpNewsletter: g
  } = Bi(), {
    createUser: p
  } = Ta(i.accounts.host), [d] = dr("scmp_user_login_type"), m = Je(c == null ? void 0 : c.useremail), y = async (h) => {
    var A, S, x;
    if ((n == null ? void 0 : n.length) === 0) return {
      error: !0
    };
    const v = await g(n.map((b) => b.entityId), h, t);
    return (A = v.errors) !== null && A !== void 0 && A.length ? {
      error: !0
    } : (n.forEach((b, w) => {
      (() => {
        var N;
        if (r === M.AcquisitionNewsletterPopup) {
          var k;
          if (w > 0 || !e) return;
          a({
            action: "sys",
            category: "nl",
            customized_parameters: {
              internal_campaign: e ?? "",
              method: m ? (k = d == null ? void 0 : d.toLowerCase()) !== null && k !== void 0 ? k : "" : "email",
              newsletter_name: b.name,
              trigger_point: "ppto"
            },
            subcategory: "sign_up"
          });
          return;
        }
        a({
          action: "sys",
          category: "nl",
          customized_parameters: {
            internal_campaign: e ?? "",
            method: m ? (N = d == null ? void 0 : d.toLowerCase()) !== null && N !== void 0 ? N : "" : "email",
            newsletter_name: b.name,
            trigger_point: xe(r)
          },
          subcategory: "sign_up"
        });
      })(), l({
        event_name: "newsletter_sign_up",
        newsletter_subscribe: b.name
      }), s({
        event: "newsletter-subscribe",
        "newsletter-id": b.entityId,
        "newsletter-name": b.name
      });
    }), {
      error: !1,
      result: {
        uid: (S = (x = v.entity) === null || x === void 0 || (x = x.uid) === null || x === void 0 || (x = x.entity) === null || x === void 0 ? void 0 : x.uid) !== null && S !== void 0 ? S : ""
      }
    });
  };
  return {
    handleSubmit: y,
    handleSubmitWithEmail: async (h, A, S) => {
      try {
        var x;
        const v = await y(h);
        if (v.error) return v;
        (x = v.result) !== null && x !== void 0 && x.uid || (await p({
          newsletterId: JSON.stringify(n.map((b) => b.entityId)),
          newsletterName: JSON.stringify(n.map((b) => b.name)),
          optIn: S ? 1 : 0,
          recaptchaToken: A,
          recaptchaVersion: "v3",
          username: h
        }), a({
          action: "sys",
          category: "login",
          customized_parameters: {
            internal_campaign: e ?? "",
            method: "email",
            result: "register_success",
            trigger_point: "ppto"
          },
          subcategory: "result"
        }));
      } catch {
        return {
          error: !0
        };
      }
      return {
        error: !1
      };
    }
  };
}, Ki = ({
  isAgreedReceiveMarketing: e,
  isDisableSignupButtonMouseOver: t,
  isShowOverlaySignUp: n,
  onSuccess: r
}) => {
  const {
    handleTrackGA4: i,
    user: a
  } = re(), {
    campaignName: s,
    newsletterItemForDisplay: l,
    newsletterItems: c,
    setLastSubscribedNewsletter: g,
    signUpButtonDisplayComponent: p,
    variant: d
  } = fe(), m = Je(a == null ? void 0 : a.useremail), [y] = dr("scmp_user_login_type"), [_, h] = be(() => m ? q.SignUpButton : n ? q.OverlaySignUpButton : q.SocialButtons), [A, S] = be(!1), x = async () => {
    if ((() => {
      var k;
      if (d !== M.AcquisitionNewsletterPopup || !s) {
        var L, o;
        i({
          action: "click",
          category: "nl",
          customized_parameters: {
            method: m ? (L = y == null ? void 0 : y.toLowerCase()) !== null && L !== void 0 ? L : "" : "email",
            newsletter_name: (o = c[0].name) !== null && o !== void 0 ? o : "",
            trigger_point: xe(d)
          },
          subcategory: "sign_up"
        });
        return;
      }
      i({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          internal_campaign: s,
          message: (k = p == null ? void 0 : p.toString()) !== null && k !== void 0 ? k : "SIGN UP NOW",
          step: "1"
        },
        subcategory: ""
      });
    })(), _ === q.OverlaySignUpButton)
      h(q.SocialButtons);
    else if (m && a !== null && a !== void 0 && a.useremail) {
      S(!0);
      const {
        error: k
      } = await b(a.useremail);
      l && (g == null || g(l.name)), !k && r();
    }
  }, v = () => {
    t || _ !== q.OverlaySignUpButton || h(q.SocialButtons);
  }, {
    handleSubmit: b,
    handleSubmitWithEmail: w
  } = $c();
  return {
    actionComponent: _,
    handleRenderActionComponent: () => {
      switch (_) {
        case q.EmailForm:
          return /* @__PURE__ */ u.createElement(Xi, {
            onPreviousClick: () => h(q.SocialButtons),
            onSubmit: async ({
              email: N,
              recaptchaToken: k
            }) => {
              var L;
              i({
                action: "click",
                category: "nl",
                customized_parameters: {
                  method: On.Email,
                  newsletter_name: (L = c[0].name) !== null && L !== void 0 ? L : "",
                  trigger_point: xe(d)
                },
                subcategory: "sign_up"
              });
              const o = await w(N, k, e);
              return !o.error && r(), o;
            }
          });
        case q.SocialButtons:
          return /* @__PURE__ */ u.createElement($i, {
            isAgreedReceiveMarketing: e,
            onEmailClick: () => {
              h(q.EmailForm);
            }
          });
        default:
          return /* @__PURE__ */ u.createElement(ji, {
            isLoading: A,
            onClick: () => void x(),
            onMouseOver: v,
            size: "large"
          }, p ?? "SIGN UP NOW");
      }
    }
  };
}, jc = (e) => /* @__PURE__ */ T.createElement("svg", { width: "18px", height: "18px", viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ T.createElement("title", null, "6D08B3E1-4507-43DB-B459-BF91FB343A6F"), /* @__PURE__ */ T.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ T.createElement("g", { id: "email_footer_3", transform: "translate(-297.000000, -361.000000)" }, /* @__PURE__ */ T.createElement("g", { id: "email_footer3", transform: "translate(32.000000, 301.000000)" }, /* @__PURE__ */ T.createElement("g", { id: "Tick", transform: "translate(0.000000, 56.000000)" }, /* @__PURE__ */ T.createElement("g", { id: "checkbox_checked", transform: "translate(265.000000, 4.000000)" }, /* @__PURE__ */ T.createElement("path", { d: "M16,0 L2,0 C0.9,0 0,0.9 0,2 L0,16 C0,17.1 0.9,18 2,18 L16,18 C17.1,18 18,17.1 18,16 L18,2 C18,0.9 17.1,0 16,0 L16,0 L16,0 Z", id: "Shape", fill: "#484848" }), /* @__PURE__ */ T.createElement("polygon", { id: "Path", fill: "#000000", points: "17 1 17 17 1 17 1 1" }), /* @__PURE__ */ T.createElement("path", { d: "M6.69230769,12.1145318 L6.69584957,12.1111217 L6.69230769,12.1145318 Z M14.3322932,5 L15,5.62497311 L7.44005099,12.6985528 L7.10176706,13 L3,9.16213131 L3.66769707,8.53714907 L7.1099159,11.7579034 L14.3322932,5 Z", id: "icon_signedup_tick", fill: "#FFFFFF", fillRule: "nonzero" }))))))), Vi = (e) => /* @__PURE__ */ T.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ T.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ T.createElement("path", { d: "M16 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z", fill: "#4585FF" }), /* @__PURE__ */ T.createElement("path", { fill: "#4585FF", d: "M17 1v16H1V1z" }), /* @__PURE__ */ T.createElement("path", { d: "M6.692 12.115l.004-.004-.004.004zM14.332 5l.668.625-7.56 7.074-.338.301L3 9.162l.668-.625 3.442 3.22L14.332 5z", fill: "#FFF", fillRule: "nonzero" }))), Hi = (e) => /* @__PURE__ */ T.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M17 1v16H1V1h16zm-1-1H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z", fill: "#CCC", fillRule: "evenodd" }));
function Ln() {
  return Ln = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ln.apply(null, arguments);
}
const Gi = ({
  isDisableSignupButtonMouseOver: e = !1,
  isShowOverlaySignUp: t = !1,
  onSuccess: n,
  ...r
}) => {
  var i, a, s, l;
  const {
    handleRoutePush: c,
    handleTrackGA4: g,
    user: p
  } = re(), d = Je(p == null ? void 0 : p.useremail), m = Bt(), [y, _] = ti(!1), {
    campaignName: h,
    newsletterItemForDisplay: A,
    summaryComponent: S,
    titleComponent: x
  } = fe(), v = () => {
    if (y) {
      var N;
      return (m == null || (N = m.signUpNewsletter) === null || N === void 0 ? void 0 : N.checkboxStyle) === "black" ? /* @__PURE__ */ u.createElement(jc, null) : /* @__PURE__ */ u.createElement(Vi, null);
    }
    return /* @__PURE__ */ u.createElement(Hi, {
      "data-qa": "render-checkbox"
    });
  }, {
    actionComponent: b,
    handleRenderActionComponent: w
  } = Ki({
    isAgreedReceiveMarketing: y,
    isDisableSignupButtonMouseOver: e,
    isShowOverlaySignUp: t,
    onSuccess: n
  }), I = Yl(A);
  return /* @__PURE__ */ u.createElement(ce, Ln({}, r, {
    "data-qa": "sign-up-newsletter"
  }), (m == null ? void 0 : m.hasSummaryLine) && /* @__PURE__ */ u.createElement(Dc, null), (m == null || (i = m.signUpNewsletter) === null || i === void 0 ? void 0 : i.hasSummary) && /* @__PURE__ */ u.createElement(Jt, null, /* @__PURE__ */ u.createElement(Zt, null, S ?? (A == null || (a = A.summary) === null || a === void 0 ? void 0 : a.text))), (m == null ? void 0 : m.hasTitle) && I && /* @__PURE__ */ u.createElement(_t, null, /* @__PURE__ */ u.createElement(pe, null, x ?? I)), (m == null || (s = m.signUpNewsletter) === null || s === void 0 ? void 0 : s.hasDescription) && /* @__PURE__ */ u.createElement(Lc, null, /* @__PURE__ */ u.createElement(Pc, null, A == null || (l = A.description) === null || l === void 0 ? void 0 : l.text)), !d && /* @__PURE__ */ u.createElement(Et, null, /* @__PURE__ */ u.createElement(Be, null, "By submitting, you consent to receiving marketing emails from SCMP. If you don't want these, tick here"), /* @__PURE__ */ u.createElement(fr, {
    onClick: _
  }, v())), /* @__PURE__ */ u.createElement(ct, {
    mode: "out-in"
  }, /* @__PURE__ */ u.createElement(dt, {
    key: b,
    timeout: 500
  }, /* @__PURE__ */ u.createElement(Ze, null, w()))), /* @__PURE__ */ u.createElement(en, null, "By registering, you agree to our", /* @__PURE__ */ u.createElement(St, {
    href: "/terms-conditions",
    onClick: (N) => {
      N.preventDefault(), g({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          destination_url: "/terms-conditions",
          internal_campaign: h ?? "",
          message: "T&C",
          step: "1"
        },
        subcategory: ""
      }), c("/terms-conditions");
    }
  }, "T&C"), "and", /* @__PURE__ */ u.createElement(St, {
    href: "/privacy-policy",
    onClick: (N) => {
      N.preventDefault(), g({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          destination_url: "/privacy-policy",
          internal_campaign: h ?? "",
          message: "Privacy Policy",
          step: "1"
        },
        subcategory: ""
      }), c("/privacy-policy");
    }
  }, "Privacy Policy")));
};
Gi.displayName = "SignUpNewsletter";
const qi = /* @__PURE__ */ E("iframe", {
  target: "emit8cs2"
})({
  name: "nw1hot",
  styles: "margin-inline-start:12px;border:none;overflow:hidden"
}), At = /* @__PURE__ */ E("div", {
  target: "emit8cs1"
})("color:#6f6f6f;font-size:12px;font-family:", H, ";line-height:16px;"), Wi = /* @__PURE__ */ E("div", {
  target: "emit8cs0"
})('display:grid;grid-template-areas:"Description LikeWidget";', qi, "{grid-area:LikeWidget;}", At, "{grid-area:Description;}");
function Pn() {
  return Pn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pn.apply(null, arguments);
}
const gr = ({
  ...e
}) => {
  const {
    config: t,
    handleTrackGA4: n
  } = re(), {
    campaignName: r,
    lastSubscribedNewsletter: i,
    variant: a
  } = fe(), {
    activeElement: s
  } = xa(), l = me((c) => {
    s === c && n({
      action: "click",
      category: "nl",
      customized_parameters: {
        internal_campaign: r ?? "",
        newsletter_name: i ?? "",
        trigger_point: xe(a)
      },
      subcategory: "like"
    });
  }, [s, n, r, a, i]);
  return /* @__PURE__ */ u.createElement(Wi, Pn({}, e, {
    "data-qa": "follow-us-on-facebook"
  }), /* @__PURE__ */ u.createElement(At, null, " Follow us on Facebook to get our latest news."), /* @__PURE__ */ u.createElement(qi, {
    allow: "autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share",
    allowFullScreen: !0,
    frameBorder: 0,
    height: "21",
    ref: l,
    scrolling: "no",
    src: t.facebook.likeUrl,
    width: "100"
  }));
};
gr.displayName = "FollowUsOnFacebook";
const Kc = (e) => /* @__PURE__ */ T.createElement("svg", { width: 25, height: 26, viewBox: "0 0 25 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M25 13C25 19.9036 19.4036 25.5 12.5 25.5C5.59644 25.5 0 19.9036 0 13C0 6.09644 5.59644 0.5 12.5 0.5C19.4036 0.5 25 6.09644 25 13Z", fill: "#FFCA05" }), /* @__PURE__ */ T.createElement("path", { d: "M10.0957 16.4492L10.0996 16.4454L10.0957 16.4492Z", fill: "#001246" }), /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.9194 19.1667L5 13.1442L7.38647 10.7473L10.9194 14.3106L17.6141 7.5L20 9.92801L10.9194 19.1667Z", fill: "#001246" })), hr = /* @__PURE__ */ E(Kc, {
  target: "evzk65t7"
})("");
var Vc = {
  name: "itm9fh",
  styles: "font-size:16px;line-height:20px"
};
const Fe = /* @__PURE__ */ E("div", {
  target: "evzk65t6"
})("grid-area:Title;font-weight:700;font-size:20px;font-family:", le, ";line-height:25px;", (e) => {
  var t;
  if (((t = e.theme) === null || t === void 0 || (t = t.signUpSuccess) === null || t === void 0 ? void 0 : t.titleFontStyle) === "small")
    return Vc;
}, ";"), tn = /* @__PURE__ */ E("div", {
  target: "evzk65t5"
})({
  name: "1mkq020",
  styles: "grid-area:Icon;inline-size:25px;block-size:25px;margin-block-end:8px"
}), tt = /* @__PURE__ */ E(gr, {
  target: "evzk65t4"
})({
  name: "1u3slon",
  styles: "margin-block-start:24px;text-align:start"
});
var Hc = {
  name: "1dgbe91",
  styles: "color:#ffffff"
}, Gc = {
  name: "d10iyn",
  styles: "color:#a1a1a1"
};
const Xe = /* @__PURE__ */ E("div", {
  target: "evzk65t3"
})("grid-area:CheckEmail;margin-block-end:8px;padding-block-start:12px;color:#000000;font-size:14px;font-family:", le, ";line-height:18px;", (e) => {
  var t, n;
  if (((t = e.theme) === null || t === void 0 || (t = t.signUpSuccess) === null || t === void 0 ? void 0 : t.checkEmailMessageStyle) === "gray")
    return Gc;
  if (((n = e.theme) === null || n === void 0 || (n = n.signUpSuccess) === null || n === void 0 ? void 0 : n.checkEmailMessageStyle) === "white")
    return Hc;
}, ";"), yr = /* @__PURE__ */ E("a", {
  target: "evzk65t2"
})("grid-area:SeeMoreLink;font-size:14px;font-family:", H, ";line-height:18px;text-decoration:underline;cursor:pointer;"), qc = /* @__PURE__ */ E("div", {
  target: "evzk65t1"
})('grid-area:Footer;display:grid;grid-template-areas:"CheckEmail" "SeeMoreLink" "FollowOnFacebook";', (e) => e.theme.breakpoints.up("mediumDesktop"), "{border-color:#eeeeee;}", yr, "{color:#4585ff;}"), Ie = /* @__PURE__ */ E("div", {
  target: "evzk65t0"
})({
  name: "1hilg2l",
  styles: 'display:grid;grid-template-areas:"Icon" "Title" "Footer";grid-template-columns:1fr;grid-column-gap:12px;justify-items:center;color:#001246;text-align:center'
});
function Bn() {
  return Bn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bn.apply(null, arguments);
}
const Yi = ({
  ...e
}) => {
  const {
    handleRoutePush: t,
    handleTrackGA4: n
  } = re(), {
    signUpSuccess: r
  } = Bt(), {
    campaignName: i,
    variant: a
  } = fe(), s = a === M.AcquisitionNewsletterPopup ? "Please check the email for further details." : "Please check your email to confirm your subscription.", l = a === M.AcquisitionNewsletterPopup ? "Thank you for your registration." : "Thanks for signing up to our newsletter!";
  return /* @__PURE__ */ u.createElement(Ie, Bn({}, e, {
    "data-qa": "sign-up-success-message"
  }), /* @__PURE__ */ u.createElement(tn, null, /* @__PURE__ */ u.createElement(hr, {
    height: 25,
    width: 25
  })), /* @__PURE__ */ u.createElement(Fe, null, l), /* @__PURE__ */ u.createElement(qc, null, (r == null ? void 0 : r.hasCheckEmail) && /* @__PURE__ */ u.createElement(Xe, null, s), (r == null ? void 0 : r.hasSeeMoreLinks) && /* @__PURE__ */ u.createElement(yr, {
    onClick: (c) => {
      c.preventDefault(), n({
        action: "click",
        category: "nl",
        customized_parameters: {
          internal_campaign: i ?? "",
          trigger_point: xe(a)
        },
        subcategory: "entry"
      }), t("/newsletters");
    }
  }, "See more newsletters"), /* @__PURE__ */ u.createElement(tt, null)));
};
Yi.displayName = "SignUpSuccessMessage";
const Wc = /* @__PURE__ */ E(Mi, {
  target: "e34cblv4"
})(""), Ct = /* @__PURE__ */ E(Gi, {
  target: "e34cblv3"
})(""), Yc = /* @__PURE__ */ E(Yi, {
  target: "e34cblv2"
})(""), Qc = {
  findOutMore: {
    titleFontStyle: "medium"
  },
  hasSummaryLine: !1,
  hasTitle: !0,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "black",
    hasDescription: !1,
    hasSummary: !0,
    summaryFontStyle: "medium",
    titleFontStyle: "medium"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !0,
    titleFontStyle: "small"
  }
};
var Jc = {
  name: "1wwwzme",
  styles: "max-inline-size:720px"
}, Zc = {
  name: "1o60ovs",
  styles: "max-inline-size:300px"
}, eu = {
  name: "1k15hls",
  styles: "max-inline-size:307px"
}, tu = {
  name: "enj17d",
  styles: "max-inline-size:640px"
};
const Qi = /* @__PURE__ */ E("div", {
  target: "e34cblv1"
})("block-size:auto;font-family:", H, ";", (e) => e.theme.breakpoints.up("desktop"), "{", (e) => {
  var t;
  switch ((t = e.theme) === null || t === void 0 || (t = t.root) === null || t === void 0 ? void 0 : t.containerSize) {
    case "large":
      return tu;
    case "medium":
      return eu;
    case "small":
      return Zc;
  }
}, " ", (e) => {
  var t;
  return ((t = e.theme) === null || t === void 0 ? void 0 : t.orientation) === "landscape" && Jc;
}, ";}", (e) => e.theme.root.customCss, ";"), nu = /* @__PURE__ */ E("div", {
  target: "e34cblv0"
})(""), ru = (e) => ai(Qc, e), iu = /* @__PURE__ */ E("div", {
  target: "e1252bbu0"
})(""), de = ({
  children: e,
  theme: t
}) => /* @__PURE__ */ u.createElement(iu, {
  "data-qa": "variant-base"
}, /* @__PURE__ */ u.createElement(Fa, {
  theme: ru(t)
}, e));
de.displayName = "VariantBase";
const au = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  hasTitle: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasSummary: !1,
    summaryFontStyle: "small",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !1,
    titleFontStyle: "medium"
  }
}, ou = /* @__PURE__ */ E("div", {
  target: "ejc3no00"
})(Qi, "{max-inline-size:100%;}", ce, "{justify-items:center;text-align:start;", se, "{background-color:#ffffff;}", Be, ",", St, ",", en, "{color:#ffffff;line-height:12px;text-align:center;}", Ue, "{min-inline-size:240px;color:#001246;font-size:14px;font-family:", H, ";background-color:#ffca05;}", Et, "{align-items:center;", Be, "{max-inline-size:278px;line-height:13px;text-align:start;opacity:0.7;}", fr, "{display:flex;svg{color:#ffffff;background-color:#ffffff;}}}", Qt, "{min-inline-size:86px;}}", Ie, "{justify-content:center;color:#ffca05;text-align:start;", Fe, "{font-size:21px;line-height:27px;text-align:center;}", Xe, "{color:#ffca05;font-size:16px;text-align:center;}", tt, "{align-items:center;}}"), su = {
  defaultDisplayComponent: J.SignUpNewsletter,
  hasResetAfterSuccess: !1,
  hasSanitizeSubscribedNewsletter: !1
};
function Un() {
  return Un = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Un.apply(null, arguments);
}
const lu = (e) => ({
  [J.SignUpNewsletter]: (t) => /* @__PURE__ */ u.createElement(Ct, Un({
    isDisableSignupButtonMouseOver: !0,
    isShowOverlaySignUp: !0,
    onSuccess: e
  }, t))
}), Ji = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(de, {
  theme: au,
  "data-qa": "acquisition-newsletter-popup-theme"
}, /* @__PURE__ */ u.createElement(ou, t, e));
Ji.displayName = "AcquisitionNewsletterPopupTheme";
const cu = (e) => /* @__PURE__ */ T.createElement("svg", { width: 15, height: 12, viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.6364 4.54544V10.6064C15.6364 10.9904 15.4866 11.3184 15.1865 11.5911C14.8863 11.8637 14.5264 12 14.1061 12H1.89388C1.47415 12 1.11368 11.8637 0.813555 11.5911C0.513983 11.3184 0.363647 10.9904 0.363647 10.6064V4.54544L8.01483 7.63631L15.6364 4.54544ZM15.6364 3.60621L8.01483 6.72756L0.363647 3.60621V1.39416C0.363647 1.01016 0.513983 0.681566 0.813555 0.40894C1.11368 0.136313 1.47415 0 1.89388 0H14.1061C14.5264 0 14.8863 0.136313 15.1865 0.40894C15.4866 0.681566 15.6364 1.01016 15.6364 1.39416V3.60621Z", fill: "white" })), Rd = /* @__PURE__ */ E("div", {
  target: "euah2f21"
})("inline-size:100%;font-size:12px;font-family:", H, ";"), uu = /* @__PURE__ */ E(cu, {
  target: "euah2f20"
})({
  name: "1o82tng",
  styles: "margin-inline-end:12px"
}), du = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "black"
  },
  orientation: "portrait",
  root: {
    containerSize: "custom",
    customCss: {
      name: "16bq70n",
      styles: "max-inline-size:260px"
    }
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasDescription: !1,
    summaryFontStyle: "medium",
    titleFontStyle: "large"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !1,
    titleFontStyle: "medium"
  }
}, mu = /* @__PURE__ */ E("div", {
  target: "e1vgfju90"
})(Ie, '{grid-template-areas:"Title Icon" "Footer Footer";grid-template-columns:1fr min-content;color:#000000;text-align:start;', Fe, "{font-weight:700;font-size:18px;font-family:", mt, ";line-height:normal;}", Xe, "{margin-block-end:12px;font-size:12px;font-family:", H, ";line-height:normal;}", tt, "{margin-block-start:0;", At, "{color:#666666;font-size:10px;line-height:normal;}}", hr, "{path:first-child{fill:#eb4254;}path:last-child{fill:#ffffff;}}}", je, "{text-align:center;", $e, "{color:#000000;}", uu, "{display:none;}}", ce, "{justify-items:left;color:#000000;font-family:", mt, ";text-align:start;", et, "{path{stroke:#000000;}}", Be, "{color:#999999;}", en, ",", St, "{color:#666666;}", se, "{background-color:#ffffff;}", ji, "{inline-size:100%;block-size:38px;}", Qt, "{min-inline-size:70px;font-size:12px;font-family:", H, ";line-height:14px;}", _t, ",", Ze, ",", Jt, "{margin-block-end:12px;}", Ze, "{inline-size:100%;}", Et, "{flex-direction:row-reverse;gap:8px;", Be, "{margin-inline-end:0;color:#333333;font-weight:400;font-size:11px;font-family:", H, ";line-height:13px;}}}");
function Fn() {
  return Fn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fn.apply(null, arguments);
}
const pu = (e) => ({
  [J.SignUpNewsletter]: (t) => /* @__PURE__ */ u.createElement(Ct, Fn({
    isShowOverlaySignUp: !0,
    onSuccess: e
  }, t))
}), Zi = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(de, {
  theme: du,
  "data-qa": "article-20-theme"
}, /* @__PURE__ */ u.createElement(mu, t, e));
Zi.displayName = "Article20Theme";
const ea = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "black"
  },
  orientation: "portrait",
  root: {
    containerSize: "custom",
    customCss: /* @__PURE__ */ ii("max-inline-size:335px;", oi.breakpoints.up("tablet"), "{max-inline-size:440px;}", "")
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasDescription: !0,
    summaryFontStyle: "medium",
    titleFontStyle: "large"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !0,
    titleFontStyle: "medium"
  }
}, ta = /* @__PURE__ */ E("div", {
  target: "e14px9co0"
})(Ie, '{grid-template-areas:"Title Icon" "Footer Footer";grid-template-columns:1fr min-content;color:#001246;text-align:start;', (e) => e.theme.breakpoints.up("tablet"), "{text-align:center;}", tt, "{margin-block-start:12px;}", hr, "{path:first-child{fill:#eb4254;}path:last-child{fill:#ffffff;}}}", je, "{text-align:center;", $e, "{color:#000000;}}", ce, "{color:#000000;text-align:center;", et, "{path{stroke:#000000;}}", Be, "{color:#999999;}", Jt, "{margin-block-end:8px;}", pe, "{color:#001246;font-weight:700;font-size:20px;line-height:23px;}", se, "{background-color:#ffffff;}}"), fu = ai(ea, {
  newsletterIcon: {
    icon: "white"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "white"
  }
}), gu = /* @__PURE__ */ E(ta, {
  target: "e1h0z9h50"
})(Ie, "{color:#ffffff;", yr, ",", At, "{color:#ffffff;}}", je, "{", $e, ",", Gt, "{color:#ffffff;}}", ce, "{color:#ffffff;", et, "{path{stroke:#ffffff;}}", pe, ",", Zt, "{color:#ffffff;}", pe, " path{fill:#ffffff;}", Ue, "{background-color:#000000;}", pe, "{color:#ffffff;}", se, "{background-color:#000000;}}"), na = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(de, {
  theme: fu,
  "data-qa": "article-dark-theme"
}, /* @__PURE__ */ u.createElement(gu, t, e));
na.displayName = "ArticleDarkTheme";
function Mn() {
  return Mn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mn.apply(null, arguments);
}
const Qr = (e) => ({
  [J.SignUpNewsletter]: (t) => /* @__PURE__ */ u.createElement(Ct, Mn({
    isShowOverlaySignUp: !0,
    onSuccess: e
  }, t))
}), ra = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(de, {
  theme: ea,
  "data-qa": "article-theme"
}, /* @__PURE__ */ u.createElement(ta, t, e));
ra.displayName = "ArticleTheme";
const hu = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "black",
    summaryFontStyle: "small",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !0,
    titleFontStyle: "medium"
  }
}, yu = /* @__PURE__ */ E("div", {
  target: "eok5vf10"
})(et, "{path{stroke:#ffffff;}}", $e, "{color:#ffffff;}", Ue, "{background-color:#000000;}", ce, "{", Be, "{color:#a1a1a1;}", pe, ",", Zt, "{color:#ffffff;}}", Ie, '{grid-template-areas:"Icon Title" ". Footer";grid-template-columns:min-content 1fr;color:#ffffff;text-align:start;', tt, "{margin-block-start:0;}", Fe, "{text-align:start;}}", (e) => e.theme.breakpoints.up("tablet"), "{", je, ",", ce, "{justify-items:flex-start;text-align:start;}}"), ia = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(de, {
  theme: hu,
  "data-qa": "footer-theme"
}, /* @__PURE__ */ u.createElement(yu, t, e));
ia.displayName = "FooterTheme";
const Eu = {
  findOutMore: {
    titleFontStyle: "large"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    summaryFontStyle: "medium",
    titleFontStyle: "medium"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !0,
    titleFontStyle: "medium"
  }
}, _u = /* @__PURE__ */ E("div", {
  target: "e1jfys6k0"
})(se, "{background-color:#ffffff;}", ce, "{", pe, "{color:#001246;}}"), aa = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(de, {
  theme: Eu,
  "data-qa": "live-article-theme"
}, /* @__PURE__ */ u.createElement(_u, t, e));
aa.displayName = "LiveArticleTheme";
const Su = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasSummary: !1,
    summaryFontStyle: "medium",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !1,
    titleFontStyle: "small"
  }
}, bu = /* @__PURE__ */ E("div", {
  target: "e1w0j1kx0"
})(pe, "{color:#001246;}", _t, "{margin-block-end:12px;}", se, "{background-color:#ffffff;}", Ct, "{color:#001246;}", Ue, "{color:#ffffff;}", Ze, "{margin-block-end:8px;}", Ie, '{grid-template-areas:"Icon Title" "Icon Footer";grid-template-columns:25px 1fr;justify-items:flex-start;max-inline-size:402.5px;margin-block:0;margin-inline:auto;text-align:start;', Fe, "{margin-block-end:4px;margin-block-end:4px;color:#001246;font-weight:400;font-family:", le, ";}", Xe, "{margin-block-end:0;padding-block-start:0;color:#000000;font-size:12px;font-family:", H, ";line-height:14px;}", tn, "{margin-block-end:0;}}"), vu = {
  defaultDisplayComponent: J.SignUpNewsletter,
  hasResetAfterSuccess: !1,
  hasSanitizeSubscribedNewsletter: !1
}, oa = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(de, {
  theme: Su,
  "data-qa": "newsletter-article-bottom-theme"
}, /* @__PURE__ */ u.createElement(bu, t, e));
oa.displayName = "NewsletterArticleBottomTheme";
const Au = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "landscape",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasSummary: !0,
    summaryFontStyle: "medium",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !1,
    titleFontStyle: "medium"
  }
}, Cu = /* @__PURE__ */ E("div", {
  target: "e1hazlo20"
})(ce, "{place-items:center center;text-align:start;", _t, "{margin-block-end:5px;}", pe, "{max-inline-size:382px;color:#001246;font-size:18px;font-family:", le, ";line-height:23px;text-align:center;}", Jt, ",", Et, ",", _t, "{", (e) => e.theme.breakpoints.up("tablet"), "{justify-self:flex-start;}}", en, "{", (e) => e.theme.breakpoints.down("tablet"), "{text-align:center;}}", Et, "{align-items:center;}", fr, "{display:flex;}", Ze, "{margin-block-end:0;}}", Ie, '{grid-template-areas:"Icon Title" "Icon Footer";grid-template-columns:25px 1fr;justify-items:flex-start;max-inline-size:402.5px;margin-block:0;margin-inline:auto;text-align:start;', Fe, "{margin-block-end:4px;color:#001246;font-weight:400;font-size:18px;font-family:", le, ";line-height:23px;", (e) => e.theme.breakpoints.up("tablet"), "{margin-block-end:8px;}}", Xe, "{margin-block-end:0;padding-block-start:0;color:#000000;font-size:14px;font-family:", H, ";line-height:18px;}", tn, "{margin-block-end:0;}}", Ue, "{margin-block-end:8px;}", pr, "{justify-content:center;margin-block-end:8px;", (e) => e.theme.breakpoints.up("tablet"), "{margin-block:10px 0;}", se, "{background-color:#ffffff;}}", Wi, "{margin-block-start:0;", At, "{display:flex;align-items:center;}}"), wu = {
  defaultDisplayComponent: J.SignUpNewsletter,
  hasResetAfterSuccess: !1,
  hasSanitizeSubscribedNewsletter: !1
}, sa = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(de, {
  theme: Au,
  "data-qa": "newsletter-article-theme"
}, /* @__PURE__ */ u.createElement(Cu, t, e));
sa.displayName = "NewsletterArticleTheme";
const Tu = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "landscape",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasSummary: !1,
    summaryFontStyle: "small",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !1,
    titleFontStyle: "medium"
  }
}, xu = /* @__PURE__ */ E("div", {
  target: "e1njrwzb0"
})(ce, "{justify-items:flex-start;text-align:start;", pe, "{max-inline-size:382px;color:#00001f;font-size:18px;font-family:", mt, ";line-height:21px;}}", Xe, ",", Fe, "{color:#00001f;}", Xe, "{margin-block-end:0;padding-block-start:8px;}", tn, "{margin-block-end:0;}", se, "{background-color:#ffffff;}", Ze, "{justify-self:center;}"), Iu = {
  defaultDisplayComponent: J.SignUpNewsletter,
  hasResetAfterSuccess: !0,
  hasSanitizeSubscribedNewsletter: !1
}, la = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(de, {
  theme: Tu,
  "data-qa": "newsletter-list-theme"
}, /* @__PURE__ */ u.createElement(xu, t, e));
la.displayName = "NewsletterListTheme";
const ku = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "black"
  },
  orientation: "portrait",
  root: {
    containerSize: "medium"
  },
  signUpNewsletter: {
    checkboxStyle: "black",
    summaryFontStyle: "small",
    titleFontStyle: "small"
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: !0,
    hasSeeMoreLinks: !0,
    titleFontStyle: "medium"
  }
}, Nu = /* @__PURE__ */ E("div", {
  target: "ez4a9ka0"
})(et, "{path{stroke:#000000;}}", $e, "{color:#000000;}", Ue, "{background-color:#000000;}", ce, "{", Be, "{color:#a1a1a1;}", pe, ",", Zt, "{color:#000000;}}", Ie, '{grid-template-areas:"Icon Title" ". Footer";grid-template-columns:min-content 1fr;color:#000000;text-align:start;', tt, "{margin-block-start:0;}", Fe, "{text-align:start;}}", (e) => e.theme.breakpoints.up("tablet"), "{", je, ",", ce, "{justify-items:flex-start;text-align:start;}}"), ca = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(de, {
  theme: ku,
  "data-qa": "posties-theme"
}, /* @__PURE__ */ u.createElement(Nu, t, e));
ca.displayName = "PostiesTheme";
const Ou = (e) => /* @__PURE__ */ T.createElement("svg", { width: 15, height: 12, viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.6364 4.54544V10.6064C15.6364 10.9904 15.4866 11.3184 15.1865 11.5911C14.8863 11.8637 14.5264 12 14.1061 12H1.89388C1.47415 12 1.11368 11.8637 0.813555 11.5911C0.513983 11.3184 0.363647 10.9904 0.363647 10.6064V4.54544L8.01483 7.63631L15.6364 4.54544ZM15.6364 3.60621L8.01483 6.72756L0.363647 3.60621V1.39416C0.363647 1.01016 0.513983 0.681566 0.813555 0.40894C1.11368 0.136313 1.47415 0 1.89388 0H14.1061C14.5264 0 14.8863 0.136313 15.1865 0.40894C15.4866 0.681566 15.6364 1.01016 15.6364 1.39416V3.60621Z", fill: "white" })), Ru = /* @__PURE__ */ E("div", {
  target: "e15wm59j1"
})("display:flex;align-items:center;color:#ffffff;font-size:14px;font-family:", H, ";text-transform:uppercase;"), Lu = /* @__PURE__ */ E(Ou, {
  target: "e15wm59j0"
})({
  name: "t5e8y3",
  styles: "margin-inline-end:10px"
}), Er = ({
  children: e
}) => /* @__PURE__ */ u.createElement(Ru, {
  "data-qa": "homepage-theme-button-display"
}, /* @__PURE__ */ u.createElement(Lu, null), e);
Er.displayName = "HomepageThemeButtonDisplay";
const Pu = /* @__PURE__ */ E("div", {
  target: "e1fn0hgx2"
})("color:#001246;font-weight:400;font-size:18px;font-family:", le, ";line-height:140%;"), Bu = /* @__PURE__ */ E("div", {
  target: "e1fn0hgx1"
})({
  name: "1b2kh57",
  styles: "font-size:14px;line-height:140%"
}), Uu = /* @__PURE__ */ E("span", {
  target: "e1fn0hgx0"
})("font-weight:700;font-family:", le, ";"), _r = ({
  className: e
}) => {
  const {
    newsletterItemForDisplay: t
  } = fe(), n = Oa(t == null ? void 0 : t.name, t == null ? void 0 : t.alternativeName);
  return /* @__PURE__ */ u.createElement(Pu, {
    className: e,
    "data-qa": "title-display"
  }, /* @__PURE__ */ u.createElement(Bu, null, "Sign-up for"), /* @__PURE__ */ u.createElement(Uu, null, n));
};
_r.displayName = "TitleDisplay";
const Fu = /* @__PURE__ */ E("div", {
  target: "eu7rj6m16"
})({
  name: "e0dnmk",
  styles: "cursor:pointer"
}), Mu = /* @__PURE__ */ E("div", {
  target: "eu7rj6m15"
})("max-inline-size:340px;margin-inline-start:8px;color:#000000;font-size:11px;font-family:", H, ";line-height:13px;text-align:start;"), Du = /* @__PURE__ */ E("div", {
  target: "eu7rj6m14"
})("display:flex;margin-block-start:24px;", (e) => e.theme.breakpoints.up("tablet"), "{margin-block-start:0;}"), zu = /* @__PURE__ */ E("div", {
  target: "eu7rj6m13"
})({
  name: "1vkjxf6",
  styles: "margin-block-end:8px"
}), Dn = /* @__PURE__ */ E("a", {
  target: "eu7rj6m12"
})({
  name: "4dv4e3",
  styles: "margin-block:0;margin-inline:2px"
}), Xu = /* @__PURE__ */ E("div", {
  target: "eu7rj6m11"
})("color:#999999;font-size:10px;font-family:", H, ";line-height:11px;white-space:nowrap;", Dn, "{color:#999999;text-decoration:underline;}"), $u = /* @__PURE__ */ E("div", {
  target: "eu7rj6m10"
})("display:flex;flex-flow:column;gap:2px;justify-items:center;max-inline-size:500px;margin:auto;padding:0;color:#ffffff;text-align:center;", Ue, "{display:flex;justify-content:center;align-items:center;block-size:36px;min-inline-size:173px;padding-inline:16px;", (e) => e.theme.breakpoints.up("tablet"), "{min-inline-size:205px;}}", Qt, "{min-inline-size:86px;font-family:", H, ";}", pr, "{justify-content:center;", se, "{background-color:#ffffff;}}", zi, "{", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:186px;}}", (e) => e.theme.breakpoints.up("tablet"), "{justify-items:center;max-inline-size:initial;margin:initial;text-align:center;}"), ju = /* @__PURE__ */ E("div", {
  target: "eu7rj6m9"
})("display:flex;flex-flow:column;gap:16px;", (e) => e.theme.breakpoints.up("tablet"), "{flex-flow:row;}"), ua = /* @__PURE__ */ E("div", {
  target: "eu7rj6m8"
})((e) => e.theme.breakpoints.up("tablet"), "{align-self:flex-end;}"), Ku = /* @__PURE__ */ E("div", {
  target: "eu7rj6m7"
})("inline-size:100%;text-align:center;", (e) => e.theme.breakpoints.up("tablet"), "{text-align:start;}"), Jr = /* @__PURE__ */ E("div", {
  target: "eu7rj6m6"
})((e) => e.theme.breakpoints.up("tablet"), "{margin-block-start:0;}"), Vu = /* @__PURE__ */ E("div", {
  target: "eu7rj6m5"
})("display:flex;flex-direction:column;align-items:center;inline-size:100%;", (e) => e.theme.breakpoints.up("tablet"), "{justify-self:end;align-items:end;inline-size:unset;}"), Zr = /* @__PURE__ */ E("div", {
  target: "eu7rj6m3"
})("display:flex;justify-content:center;", (e) => e.theme.breakpoints.up("tablet"), "{gap:16px;justify-content:unset;}"), Hu = /* @__PURE__ */ E("div", {
  target: "eu7rj6m2"
})("display:none;", (e) => e.theme.breakpoints.up("tablet"), "{display:block;inline-size:100%;}"), Gu = /* @__PURE__ */ E("div", {
  target: "eu7rj6m1"
})("display:block;", (e) => e.theme.breakpoints.up("tablet"), "{display:none;}"), qu = /* @__PURE__ */ E(_r, {
  target: "eu7rj6m0"
})({
  name: "c79c4p",
  styles: "margin-block-start:12px"
}), Wu = {
  findOutMore: {
    titleFontStyle: "small"
  },
  hasSummaryLine: !1,
  newsletterIcon: {
    icon: "white"
  },
  orientation: "landscape",
  root: {
    containerSize: "medium",
    customCss: /* @__PURE__ */ ii("max-inline-size:100%;", oi.breakpoints.up("desktop"), "{max-inline-size:100%;}", "")
  }
}, Yu = /* @__PURE__ */ E("div", {
  target: "e1ds7hvh0"
})("padding-block:20px;padding-inline:24px;border:1px solid rgba(0, 0, 0, 0.2);border-radius:4px;background:#f6f6f6;", ua, "{margin-block-end:-8px;}", je, '{grid-template-areas:"Message" "Button";gap:16px;place-items:center center;', (e) => e.theme.breakpoints.up("tablet"), '{grid-template-areas:"Message Button";justify-items:flex-start;}', Gt, "{padding-block:10px;padding-inline:16px;border-radius:2px;background-color:#4585ff;}", sr, "{margin-block:0;", (e) => e.theme.breakpoints.up("tablet"), "{margin-inline-start:12px;}}", cr, "{", (e) => e.theme.breakpoints.up("tablet"), "{justify-self:end;}}", $e, "{color:#001246;", (e) => e.theme.breakpoints.up("tablet"), "{font-size:18px;line-height:23px;}}", lr, "{display:none;}}"), zn = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.createElement(de, {
  theme: Wu,
  "data-qa": "homepage-theme"
}, /* @__PURE__ */ u.createElement(Yu, t, e)), Ld = () => /* @__PURE__ */ u.createElement(Er, {
  "data-qa": "homepage-theme-sign-up-button-display"
}, "Get Our Newsletter"), Pd = () => /* @__PURE__ */ u.createElement(Er, {
  "data-qa": "homepage-theme-find-our-more-display"
}, "Find Out More");
zn.displayName = "HomepageTheme";
const Qu = /* @__PURE__ */ E("div", {
  target: "ebzef8g0"
})("color:#001246;font-weight:400;font-size:14px;font-family:", le, ";line-height:140%;"), Xn = () => {
  var e;
  const {
    newsletterItemForDisplay: t
  } = fe();
  return /* @__PURE__ */ u.createElement(Qu, {
    "data-qa": "description-display"
  }, t == null || (e = t.homepageDescription) === null || e === void 0 ? void 0 : e.text);
};
Xn.displayName = "DescriptionDisplay";
const Ju = (e) => /* @__PURE__ */ T.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ T.createElement("g", { id: "icon_email_24x24" }, /* @__PURE__ */ T.createElement("path", { id: "Fill 45", fillRule: "evenodd", clipRule: "evenodd", d: "M22 10.0606V18.1419C22 18.6539 21.8039 19.0912 21.4108 19.4547C21.0178 19.8182 20.5465 20 19.9961 20H4.00388C3.45423 20 2.98218 19.8182 2.58917 19.4547C2.19687 19.0912 2 18.6539 2 18.1419V10.0606L12.0194 14.1818L22 10.0606ZM22 8.80827L12.0194 12.9701L2 8.80827V5.85888C2 5.34688 2.19687 4.90876 2.58917 4.54525C2.98218 4.18175 3.45423 4 4.00388 4H19.9961C20.5465 4 21.0178 4.18175 21.4108 4.54525C21.8039 4.90876 22 5.34688 22 5.85888V8.80827Z", fill: "#4585FF" }))), Zu = /* @__PURE__ */ E("div", {
  target: "essnwrk3"
})({
  name: "zpo6p0",
  styles: "display:flex;block-size:100%"
}), ed = /* @__PURE__ */ E("div", {
  target: "essnwrk2"
})("display:flex;flex-direction:row;gap:4px;justify-content:space-between;align-items:center;inline-size:100%;padding-block-end:8px;border-block-end:1px solid #001246;", (e) => e.theme.breakpoints.up("tablet"), "{flex-direction:column;justify-content:unset;align-items:flex-start;padding-block-end:0;padding-inline-end:16px;border-block-end:0;border-inline-end:1px solid #001246;}"), td = /* @__PURE__ */ E("span", {
  target: "essnwrk1"
})("display:flex;gap:8px;align-items:center;color:#4585ff;font-weight:700;font-size:14px;font-family:", mt, ";text-transform:uppercase;"), nd = /* @__PURE__ */ E("div", {
  target: "essnwrk0"
})("color:#001246;font-weight:700;font-size:14px;font-family:", mt, ";text-align:start;"), $n = () => {
  var e;
  const {
    newsletterItemForDisplay: t
  } = fe();
  return /* @__PURE__ */ u.createElement(Zu, {
    "data-qa": "summary-display"
  }, /* @__PURE__ */ u.createElement(ed, null, /* @__PURE__ */ u.createElement(td, null, /* @__PURE__ */ u.createElement(Ju, null), "NEWSLETTER"), /* @__PURE__ */ u.createElement(nd, null, t == null || (e = t.summary) === null || e === void 0 ? void 0 : e.text)));
};
$n.displayName = "SummaryDisplay";
function jn() {
  return jn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jn.apply(null, arguments);
}
const da = ({
  isDisableSignupButtonMouseOver: e = !1,
  isShowOverlaySignUp: t = !1,
  onSuccess: n,
  ...r
}) => {
  const {
    handleRoutePush: i,
    handleTrackGA4: a
  } = re(), [s, l] = ti(!1), {
    campaignName: c
  } = fe(), g = () => s ? /* @__PURE__ */ u.createElement(Vi, null) : /* @__PURE__ */ u.createElement(Hi, {
    "data-qa": "render-checkbox"
  }), {
    actionComponent: p,
    handleRenderActionComponent: d
  } = Ki({
    isAgreedReceiveMarketing: s,
    isDisableSignupButtonMouseOver: e,
    isShowOverlaySignUp: t,
    onSuccess: n
  }), m = () => /* @__PURE__ */ u.createElement(Du, {
    "data-qa": "handle-render-agreement"
  }, /* @__PURE__ */ u.createElement(Fu, {
    onClick: l
  }, g()), /* @__PURE__ */ u.createElement(Mu, null, "By submitting, you consent to receiving marketing emails from SCMP. If you don't want these, tick here")), y = () => {
    const h = () => p === q.OverlaySignUpButton || p === q.SignUpButton ? /* @__PURE__ */ u.createElement(u.Fragment, null, /* @__PURE__ */ u.createElement(Jr, null, /* @__PURE__ */ u.createElement($n, null)), /* @__PURE__ */ u.createElement(Ku, null, /* @__PURE__ */ u.createElement(_r, null), /* @__PURE__ */ u.createElement(Xn, null))) : m();
    return /* @__PURE__ */ u.createElement(Hu, {
      "data-qa": "handle-render-tablet-up-content"
    }, /* @__PURE__ */ u.createElement(ct, {
      mode: "out-in"
    }, /* @__PURE__ */ u.createElement(dt, {
      key: String(p === q.OverlaySignUpButton || p === q.SignUpButton),
      timeout: 500
    }, /* @__PURE__ */ u.createElement(Zr, null, h()))));
  }, _ = () => {
    const h = () => p === q.OverlaySignUpButton || p === q.SignUpButton ? /* @__PURE__ */ u.createElement(Xn, null) : m();
    return /* @__PURE__ */ u.createElement(Gu, {
      "data-qa": "handle-render-mobile-content"
    }, /* @__PURE__ */ u.createElement(Jr, null, /* @__PURE__ */ u.createElement($n, null)), /* @__PURE__ */ u.createElement(qu, null), /* @__PURE__ */ u.createElement(ct, {
      mode: "out-in"
    }, /* @__PURE__ */ u.createElement(dt, {
      key: String(p === q.OverlaySignUpButton || p === q.SignUpButton),
      timeout: 500
    }, /* @__PURE__ */ u.createElement(Zr, null, h()))));
  };
  return /* @__PURE__ */ u.createElement($u, jn({}, r, {
    "data-qa": "sign-up-newsletter"
  }), /* @__PURE__ */ u.createElement(ju, null, y(), _(), /* @__PURE__ */ u.createElement(Vu, null, /* @__PURE__ */ u.createElement(ct, {
    mode: "out-in"
  }, /* @__PURE__ */ u.createElement(dt, {
    key: p,
    timeout: 500
  }, /* @__PURE__ */ u.createElement(zu, null, d()))))), /* @__PURE__ */ u.createElement(ua, null, /* @__PURE__ */ u.createElement(Xu, null, "By registering, you agree to our", /* @__PURE__ */ u.createElement(Dn, {
    href: "/terms-conditions",
    onClick: (h) => {
      h.preventDefault(), a({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          destination_url: "/terms-conditions",
          internal_campaign: c ?? "",
          message: "T&C",
          step: "1"
        },
        subcategory: ""
      }), i("/terms-conditions");
    }
  }, "T&C"), "and", /* @__PURE__ */ u.createElement(Dn, {
    href: "/privacy-policy",
    onClick: (h) => {
      h.preventDefault(), a({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          destination_url: "/privacy-policy",
          internal_campaign: c ?? "",
          message: "Privacy Policy",
          step: "1"
        },
        subcategory: ""
      }), i("/privacy-policy");
    }
  }, "Privacy Policy"))));
};
da.displayName = "SignUpNewsletter";
const rd = (e) => /* @__PURE__ */ T.createElement("svg", { width: 25, height: 25, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25ZM18.2767 8L19 8.70309L10.8101 16.6609L10.4436 17L6 12.6824L6.72334 11.9793L10.4524 15.6026L18.2767 8Z", fill: "#EB4254" })), id = /* @__PURE__ */ E(rd, {
  target: "e18vlar15"
})(""), ad = /* @__PURE__ */ E("div", {
  target: "e18vlar14"
})("grid-area:Title;font-weight:400;font-size:18px;font-family:", le, ";line-height:23px;text-align:center;", (e) => e.theme.breakpoints.up("tablet"), "{font-weight:700;line-height:25px;text-align:start;}"), od = /* @__PURE__ */ E("div", {
  target: "e18vlar13"
})({
  name: "1mkq020",
  styles: "grid-area:Icon;inline-size:25px;block-size:25px;margin-block-end:8px"
}), sd = /* @__PURE__ */ E(gr, {
  target: "e18vlar12"
})('grid-area:FollowUsOnFacebook;grid-template-areas:"Description" "LikeWidget";grid-row-gap:4px;justify-items:center;text-align:center;', (e) => e.theme.breakpoints.up("tablet"), "{justify-items:end;justify-self:end;text-align:start;}"), ld = /* @__PURE__ */ E("div", {
  target: "e18vlar11"
})("grid-area:CheckEmail;color:#001246;font-size:12px;font-family:", H, ";line-height:18px;text-align:center;"), cd = /* @__PURE__ */ E("div", {
  target: "e18vlar10"
})('display:grid;grid-template:"Icon" min-content "." 20px "Title" min-content "CheckEmail" min-content "." 48px "FollowUsOnFacebook" min-content/fit-content(100%);place-items:center;justify-content:center;color:#001246;', (e) => e.theme.breakpoints.up("tablet"), '{grid-template:"Icon Title FollowUsOnFacebook" min-content "Icon CheckEmail FollowUsOnFacebook" min-content/max-content fit-content(50%) 1fr max-content;grid-gap:4px 12px;place-items:center start;}');
function Kn() {
  return Kn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Kn.apply(null, arguments);
}
const ma = ({
  ...e
}) => /* @__PURE__ */ u.createElement(cd, Kn({}, e, {
  "data-qa": "sign-up-success-message"
}), /* @__PURE__ */ u.createElement(od, null, /* @__PURE__ */ u.createElement(id, {
  height: 25,
  width: 25
})), /* @__PURE__ */ u.createElement(ad, null, "Thanks for signing up to our newsletter!"), /* @__PURE__ */ u.createElement(ld, null, "Please check your email to confirm your subscription."), /* @__PURE__ */ u.createElement(sd, null));
ma.displayName = "SignUpSuccessMessage";
function Vn() {
  return Vn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vn.apply(null, arguments);
}
const ei = (e) => ({
  [J.SignUpNewsletter]: (t) => /* @__PURE__ */ u.createElement(da, Vn({
    isShowOverlaySignUp: !0,
    onSuccess: e
  }, t)),
  [J.SignUpSuccessMessage]: (t) => /* @__PURE__ */ u.createElement(ma, null)
});
function Hn() {
  return Hn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hn.apply(null, arguments);
}
const ud = {
  defaultDisplayComponent: J.FindOutMore,
  hasResetAfterSuccess: !0,
  hasSanitizeSubscribedNewsletter: !0
}, dd = ({
  campaignName: e,
  children: t,
  hideWhenNoNewsletters: n = !1,
  isToggleSuccessMessage: r = !1,
  multipleNewsletters: i = !1,
  newsletterItems: a,
  onSuccess: s,
  trigger_point: l,
  variant: c,
  ...g
}) => {
  var p;
  const d = De(() => ({
    [M.AcquisitionNewsletterPopup]: {
      config: su,
      hook: lu,
      renderComponent: Ji
    },
    [M.Article]: {
      hook: Qr,
      renderComponent: ra
    },
    [M.Article20]: {
      hook: pu,
      renderComponent: Zi
    },
    [M.ArticleDark]: {
      hook: Qr,
      renderComponent: na
    },
    [M.Footer]: {
      renderComponent: ia
    },
    [M.Homepage]: {
      hook: ei,
      renderComponent: zn
    },
    [M.LiveArticle]: {
      renderComponent: aa
    },
    [M.NewsletterArticle]: {
      config: wu,
      renderComponent: sa
    },
    [M.NewsletterArticleBottom]: {
      config: vu,
      renderComponent: oa
    },
    [M.NewsletterList]: {
      config: Iu,
      renderComponent: la
    },
    [M.Posties]: {
      renderComponent: ca
    },
    [M.Section]: {
      hook: ei,
      renderComponent: zn
    }
  }), []), m = De(() => d[c].renderComponent, [d, c]), y = De(() => {
    var K;
    return (K = d[c].config) !== null && K !== void 0 ? K : ud;
  }, [d, c]), [_, h] = be(!1), A = me(() => {
    C(J.SignUpSuccessMessage), y.hasResetAfterSuccess && h(!0), s == null || s();
  }, [s, y]), S = {
    [J.FindOutMore]: (K) => /* @__PURE__ */ u.createElement(Wc, K),
    [J.SignUpNewsletter]: (K) => /* @__PURE__ */ u.createElement(Ct, Hn({
      onSuccess: A
    }, K)),
    [J.SignUpSuccessMessage]: (K) => /* @__PURE__ */ u.createElement(Yc, K)
  };
  Ye(() => {
    if (!_) return;
    const K = setTimeout(() => h(!1), Ca);
    return () => clearTimeout(K);
  }, [_, y.hasResetAfterSuccess]);
  const x = d[c].hook, v = (p = x == null ? void 0 : x(A)) !== null && p !== void 0 ? p : {}, b = Object.entries({
    ...S,
    ...v
  }).reduce((K, [he, Ne]) => (K[he] = Ne(), K), {}), w = Wl(), I = ha(() => y.hasSanitizeSubscribedNewsletter ? a.filter((K) => !w.includes(K.entityId)) : a, [a, w, y.hasSanitizeSubscribedNewsletter]), N = De(() => bi(I), [I]), k = me(() => ({
    action: "imp",
    category: "nl",
    customized_parameters: {
      internal_campaign: e,
      newsletter_name: N == null ? void 0 : N.name,
      trigger_point: l ?? xe(c)
    },
    subcategory: "sign_up"
  }), [N, l, c, e]), {
    captureTrackImpressionEventTargetElement: L
  } = sl({
    ga4Event: k
  }), [o, C] = be(y.defaultDisplayComponent), O = me(() => {
    C(I.length > 0 ? J.SignUpNewsletter : y.defaultDisplayComponent);
  }, [I, y.defaultDisplayComponent]), R = ba(O);
  Ye(() => {
    _ || R.current();
  }, [_, R]), Ye(() => {
    r ? C(J.SignUpSuccessMessage) : R.current();
  }, [r, R]);
  const {
    dataMatrix: B,
    findOutMoreButtonDisplayComponent: W,
    queryParametersForSocialButtons: ge,
    signUpButtonDisplayComponent: wt,
    summaryComponent: ke,
    titleComponent: Tt
  } = g;
  return n && I.length === 0 ? null : /* @__PURE__ */ u.createElement(ll, {
    multipleNewsletters: i,
    value: {
      campaignName: e,
      dataMatrix: B,
      findOutMoreButtonDisplayComponent: W,
      newsletterItems: I,
      queryParametersForSocialButtons: ge,
      signUpButtonDisplayComponent: wt,
      summaryComponent: ke,
      titleComponent: Tt,
      variant: c
    },
    "data-qa": "newsletter-widget"
  }, t, /* @__PURE__ */ u.createElement(m, g, /* @__PURE__ */ u.createElement(Qi, {
    ref: L
  }, /* @__PURE__ */ u.createElement(ct, {
    mode: "out-in"
  }, /* @__PURE__ */ u.createElement(dt, {
    appear: !1,
    key: o,
    timeout: 500
  }, /* @__PURE__ */ u.createElement(nu, null, Object.entries(b).map(([K, he]) => /* @__PURE__ */ u.createElement(u.Fragment, {
    key: K
  }, K === o && he))))))));
};
dd.displayName = "NewsletterWidget";
export {
  Fe as A,
  Xe as B,
  Rd as C,
  At as D,
  Od as E,
  gr as F,
  sl as G,
  Pd as H,
  Nd as M,
  dd as N,
  uu as S,
  Zs as T,
  M as V,
  ll as a,
  Ld as b,
  _c as c,
  Wl as d,
  $c as e,
  Ki as f,
  xe as g,
  E as h,
  dt as i,
  bi as j,
  fi as k,
  Kt as l,
  Oe as m,
  ps as n,
  Js as o,
  fe as p,
  Yl as q,
  ci as r,
  Ga as s,
  Yo as t,
  Bi as u,
  to as v,
  ms as w,
  dr as x,
  Yi as y,
  tt as z
};
//# sourceMappingURL=index-BBPp1-L5.mjs.map
